<template>
  <div class="sc-popup-container sc-checkout-container" :style="`z-index:${highestZIndex + 2}`"
    :class="{ fadeOutTop: !show }">
    <div v-if="isPaddleActive && ![0, 1].includes(form.pay_method)" class="payment-type-wrapper sc-form"
      style="padding: 42px 60px 30px;">
      <a class="sc-back" @click="closeCheckout" href="javascript:"
        :style="`background-image:url(${scBaseUrl}/assets/images/Back.svg)`"></a>
      <PriceComponent :price="price" :vat="vat" :has-parent="hasParent" :show="show" />

      <div v-if="offer.options.length > 1" v-show="!isThirdParty" class="sc-product-options mrgt-20">
        <h2>Product option</h2>
        <BaseFormRow>
          <div class="sc-form-select-container sc-form-product-options">
            <div class="sc-select-box" :class="{
              'sc-select-has-error': errors.includes('optionId')
                ? true
                : false,
            }">
              <div @click="showProductOptions = !showProductOptions" class="sc-select-button brd"
                ref="product-options-sc-selectbox" :class="{
                  'open-select-box': showProductOptions,
                }" :style="`z-index:${highestZIndex + 17}`">
                <div class="sc-selected-value">
                  <span>
                    {{
                      selectedProductOption.name ||
                      "Product Options" | TitleString
                    }}
                    <!-- <span>({{ selectedProductOption.price }} USD, {{ selectedProductOption.duration }} days)</span> -->
                  </span>
                </div>
                <div class="sc-select-chevrons">
                  <img :src="`${scBaseUrl}/assets/images/symbols-arrow.png`" alt />
                </div>
              </div>
              <transition enter-active-class="fadeInFast" mode="out-in">
                <div v-if="showProductOptions" v-closable="{
                  exclude: ['product-options-sc-selectbox'],
                  handler: 'onCloseProductOptions',
                }" class="sc-options" :style="`z-index:${highestZIndex + 16}`">
                  <div class="sc-option" :class="{ 'sc-selected': option.ID == form.optionId }"
                    v-for="(option, index) in offer.options" :key="'product_options_' + index + '_' + option.name"
                    @click="form.optionId = option.ID">
                    <span class="sc-select-option-label">
                      {{ option.name | TitleString }}
                      <!-- <span>({{ option.price }} USD, {{ option.duration }} days)</span> -->
                    </span>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </BaseFormRow>
      </div>
      <div class="sc-product-options mrgt-0">
        <h2 v-if="!userId">Email address</h2>
        <BaseFormRow :class="{
          'mb-0': isEmailExist,
        }" v-if="!userId">
          <BaseInput :id="`${widgetKey}_email`" v-model="form.email" placeholder="Your email"
            :readonly="readOnly.includes('email') ? true : false" :error="errors.includes('email') ? true : false"
            :error-message="errorMessages.hasOwnProperty('email')
              ? errorMessages.email
              : ''
              " validation="email" :tip="tipALign" type="email" @blur="checkEmailExist" />
        </BaseFormRow>
      </div>
      <template v-if="availableProviders.includes('PAYPAL')">
        <h2
          style="text-align: center; font-size: 22px; font-weight: normal; font-family: latoregular; padding: 20px 5px 15px 5px;">
          How do you want to pay?
        </h2>
        <div style="width: 70px;height: 5px;background-color: #ffd96b;margin: 0 auto;border-radius: 2px;"></div>
        <div class="sc-flex" style="padding: 30px;margin: 0 auto; text-align: center;">
          <a @click="setPayType(0)">
            <img class="sc-purchase-modal__paypal-method-img" :src="`${scBaseUrl}/assets/images/credit_card_method.png`"
              alt="Credit Card" style="width: 100px; margin: 20px;" />
          </a>
          <a @click="setPayType(1)">
            <img class="sc-purchase-modal__paypal-method-img" :src="`${scBaseUrl}/assets/images/paypal_method.png`"
              alt="paypal" style="width: 100px; margin: 20px;" />
          </a>
        </div>
      </template>
      <template v-else>
        <BaseFormRow class="relative mrgt-20">
          <BaseButton variant="big-button" type="button" @click="setPayType(0)">{{
            payButtonText
          }}</BaseButton>
        </BaseFormRow>
      </template>
      <p class="sc-faq-wrap" v-if="!isPaddleOpen && offer.faq && offer.faq.status">
        <Faq :faq="offer.faq" />
      </p>
    </div>
    <div v-else>
      <form v-show="isPaddleActive && form.pay_method == 0" class="sc-form" :class="{ fadeInBottom: show }"
        :key="`sc-form-paddle-${offer.secret}`" @submit.prevent="_submitForm" autocomplete="off"
        :style="`min-height:450px;z-index:${highestZIndex};${customHeight}`">
        <a class="sc-back" @click="closeCheckout" href="javascript:"
          :style="`background-image:url(${scBaseUrl}/assets/images/Back.svg)`"></a>

        <PriceComponent :price="price" :vat="vat" :has-parent="hasParent" :show="show" />

        <div class="sc-messages">
          <p class="sc-error-text" v-if="resultErrorMessage.length" v-html="resultErrorMessage"></p>
          <p class="sc-error-text" v-if="walletError" v-html="walletError"></p>
        </div>
        <div class="paddleform"></div>
        <p class="sc-faq-wrap" v-if="!isPaddleOpen && offer.faq && offer.faq.status">
          <Faq :faq="offer.faq" />
        </p>
      </form>
      <form v-if="!isPaddleActive && showQuickPurchase" class="sc-form sc-quick-buy" :class="{ fadeInBottom: show }"
        :key="`purchase-sc-form-${offer.secret}`" @submit.prevent="submitFormQuickBuy" autocomplete="off"
        :style="`z-index:${highestZIndex}`">
        <a class="sc-back" @click="closeCheckout" href="javascript:"
          :style="`background-image:url(${scBaseUrl}/assets/images/Back.svg)`"></a>
        <PriceComponent :price="price" :vat="vat" :has-parent="hasParent" :show="show" />
        <h2>
          Buy
          <span class="sc-link sc-link_color_green" v-html="$options.filters.cleanHTML(offer.title)"></span>
          <template v-if="!offer.options || !offer.options.length">
            for <span :id="`${widgetKey}_price`">${{ price }}</span></template>
          ?
        </h2>

        <div class="sc-messages">
          <p class="sc-error-text" v-if="resultErrorMessage.length" v-html="resultErrorMessage"></p>
          <p v-if="walletError" class="sc-error-text" v-html="walletError"></p>
        </div>

        <div v-if="offer.options.length > 1" v-show="!isThirdParty" class="sc-product-options mrgt-20">
          <BaseFormRow>
            <div class="sc-form-select-container sc-form-product-options">
              <div class="sc-select-box" :class="{
                'sc-select-has-error': errors.includes('optionId')
                  ? true
                  : false,
              }">
                <div @click="showProductOptions = !showProductOptions" class="sc-select-button brd"
                  ref="product-options-sc-selectbox" :class="{
                    'open-select-box': showProductOptions,
                  }" :style="`z-index:${highestZIndex + 17}`">
                  <div class="sc-selected-value">
                    <span>
                      {{
                        selectedProductOption.name ||
                        "Product Options" | TitleString
                      }}
                      <!-- <span>({{ selectedProductOption.price }} USD, {{ selectedProductOption.duration }} days)</span> -->
                    </span>
                  </div>
                  <div class="sc-select-chevrons">
                    <img :src="`${scBaseUrl}/assets/images/symbols-arrow.png`" alt />
                  </div>
                </div>
                <transition enter-active-class="fadeInFast" mode="out-in">
                  <div v-if="showProductOptions" v-closable="{
                    exclude: ['product-options-sc-selectbox'],
                    handler: 'onCloseProductOptions',
                  }" class="sc-options" :style="`z-index:${highestZIndex + 16}`">
                    <div class="sc-option" :class="{ 'sc-selected': option.ID == form.optionId }"
                      v-for="(option, index) in offer.options" :key="'product_options_' + index + '_' + option.name"
                      @click="form.optionId = option.ID">
                      <span class="sc-select-option-label">
                        {{ option.name | TitleString }}
                        <!-- <span>({{ option.price }} USD, {{ option.duration }} days)</span> -->
                      </span>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </BaseFormRow>
        </div>
        <template v-if="!isWalletSetup">
          <BaseFormRow>
            <div class="sc-form-select-container sc-user-type">
              <div class="sc-select-box" :class="{
                'sc-select-has-error': errors.includes('user_type')
                  ? true
                  : false,
              }">
                <label for="user_type">I'm a</label>

                <div @click="showUserTypes = !showUserTypes" class="sc-select-button brd" ref="user-type-sc-selectbox"
                  :class="{
                    'open-select-box': showUserTypes,
                  }">
                  <div class="sc-selected-value">
                    <span>{{ activeUserType }}</span>
                  </div>
                  <div class="sc-select-chevrons cursor-pointer">
                    <img :src="`${scBaseUrl}/assets/images/symbols-arrow.png`" alt />
                  </div>
                </div>
                <transition enter-active-class="fadeInFast" mode="out-in">
                  <div v-if="showUserTypes" v-closable="{
                    exclude: ['user-type-sc-selectbox'],
                    handler: 'onCloseUserType',
                  }" class="sc-options">
                    <div class="sc-option" :class="{ 'sc-selected': form.user_type == 1 }" key="user_type_1"
                      @click="form.user_type = 1">
                      <span class="sc-select-option-label">Private User</span>
                    </div>
                    <div class="sc-option" :class="{ 'sc-selected': form.user_type == 2 }" key="user_type_2"
                      @click="form.user_type = 2">
                      <span class="sc-select-option-label">Business</span>
                    </div>
                    <div class="sc-option" :class="{ 'sc-selected': form.user_type == 3 }" key="user_type_3"
                      @click="form.user_type = 3">
                      <span class="sc-select-option-label">Organization</span>
                    </div>
                    <div class="sc-option" :class="{ 'sc-selected': form.user_type == 4 }" key="user_type_4"
                      @click="form.user_type = 4">
                      <span class="sc-select-option-label">Sole trader</span>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <template v-if="!userId">
              <a v-if="isSelfHosted && !iframe" data-target="#login" data-toggle="modal" class="sc-login-link flex"
                data-dismiss="modal" data-backdrop="static" data-keyboard="false" @click="closeCheckout">
                Already a user?<span class="has-tooltip">
                  <img :src="`${scBaseUrl}/assets/images/info.svg`" alt="info" />
                  <BaseToolTip
                    text="This product is sold on Sellcodes.com. If you already have a Sellcodes account, please click to login."
                    class="tooltip-text" tip="bottom-right"></BaseToolTip>
                </span>
              </a>
              <a v-else class="sc-login-link flex" target="_blank"
                :href="`${scBaseUrl}/${offer.secret_link}/?embLogin=1`">
                Already a user?<span class="has-tooltip">
                  <img :src="`${scBaseUrl}/assets/images/info.svg`" alt="info" />
                  <BaseToolTip
                    text="This product is sold on Sellcodes.com. If you already have a Sellcodes account, please click to login."
                    class="tooltip-text" tip="bottom-right"></BaseToolTip>
                </span>
              </a>
            </template>
          </BaseFormRow>
          <transition enter-active-class="fadeInTop" leave-active-class="fadeOut" mode="out-in">
            <div v-if="[2, 3, 4].includes(form.user_type)" key="businessUserBlock" id="businessUserBlock">
              <BaseFormRow>
                <BaseInput :id="`${widgetKey}_business_name`" v-model="form.business_name" placeholder="Business name"
                  :error="errors.includes('business_name') ? true : false" :error-message="errorMessages.hasOwnProperty('business_name')
                    ? errorMessages.business_name
                    : ''
                    " :required="true" class="mrgrt-8" />
                <BaseSelect :id="`${widgetKey}_residence_business`" v-model="form.residence_business"
                  placeholder="Business residence" :options="countries" option-label="name" option-value="alpha_2"
                  option-input="alpha_3" option-sub-label="alpha_3" label="Business residence"
                  :error="errors.includes('residence_business') ? true : false" :error-message="errorMessages.hasOwnProperty('residence_business')
                    ? errorMessages.residence_business
                    : ''
                    " :required="true" class="mrglt-8" />
              </BaseFormRow>
              <BaseFormRow v-if="isEU && !showEUVat">
                <a href="javascript:" @click="showEUVat = !showEUVat" class="vat-toggle-link">Have an EU VAT number?</a>
              </BaseFormRow>

              <transition enter-active-class="fadeInTop" leave-active-class="fadeOut" mode="out-in">
                <template v-if="isEU && showEUVat">
                  <BaseFormRow>
                    <BaseInput :id="`${widgetKey}_eu_vat_number`" v-model="form.eu_vat_number" placeholder="EU VAT number"
                      :error="form.eu_vat_number.length &&
                        (errors.includes('eu_vat_number') ||
                          errorMessages.hasOwnProperty('eu_vat_number'))
                        ? true
                        : false
                        " :success="form.eu_vat_valid == 1 && form.eu_vat_number.length
    " :success-message="successMessages.hasOwnProperty('eu_vat_number')
    ? successMessages.eu_vat_number
    : ''
    " :error-message="errorMessages.hasOwnProperty('eu_vat_number')
    ? errorMessages.eu_vat_number
    : ''
    " size="w-75" :is-vat="true" />
                    <BaseButton size="w-25 h-40" variant="invert" type="button" @click="checkVatNumber('vat')"
                      :loading="vatLoader">Check</BaseButton>
                  </BaseFormRow>
                </template>
              </transition>
              <BaseFormRow>
                <h2>Legal representative</h2>
              </BaseFormRow>
              <BaseFormRow>
                <BaseInput :id="`${widgetKey}_first_name_b`" v-model="form.first_name" placeholder="First name"
                  size="w-50" :error="errors.includes('first_name') ? true : false" :error-message="errorMessages.hasOwnProperty('first_name')
                    ? errorMessages.first_name
                    : ''
                    " :required="true" class="mrgrt-8" />
                <BaseInput :id="`${widgetKey}_last_name_b`" v-model="form.last_name" placeholder="Last name"
                  :error="errors.includes('last_name') ? true : false" :error-message="errorMessages.hasOwnProperty('last_name')
                    ? errorMessages.last_name
                    : ''
                    " :tip="tipALign" :required="true" size="w-50" class="mrglt-8" />
              </BaseFormRow>
              <BaseFormRow :class="{
                'mb-0': isEmailExist,
              }" v-if="!userId" v-show="!isThirdParty">
                <BaseInput :id="`${widgetKey}_email_b`" v-model="form.email" placeholder="Your email"
                  :readonly="readOnly.includes('email') ? true : false" :error="errors.includes('email') ? true : false"
                  :error-message="errorMessages.hasOwnProperty('email')
                    ? errorMessages.email
                    : ''
                    " validation="email" :tip="tipALign" type="email" @blur="checkEmailExist" />
              </BaseFormRow>
              <p class="email-exists-error" v-if="isEmailExist">
                You already seem to have a Sellcodes account.
                <a v-if="isSelfHosted" data-target="#login" data-toggle="modal" class="sc-login-link flex"
                  data-dismiss="modal" data-backdrop="static" data-keyboard="false">
                  Please login
                </a>
                <a v-else class="sc-login-link flex" target="_blank"
                  :href="`${scBaseUrl}/${offer.secret_link}/?embLogin=1`">
                  Please login
                </a>
              </p>
            </div>
            <div v-else key="privateUserBlock">
              <BaseFormRow>
                <BaseInput :id="`${widgetKey}_first_name`" v-model="form.first_name" placeholder="First name" size="w-50"
                  :required="true" :error="errors.includes('first_name') ? true : false" :error-message="errorMessages.hasOwnProperty('first_name')
                    ? errorMessages.first_name
                    : ''
                    " class="mrgrt-8" />
                <BaseInput :id="`${widgetKey}_last_name`" v-model="form.last_name" placeholder="Last name"
                  :required="true" :error="errors.includes('last_name') ? true : false" :error-message="errorMessages.hasOwnProperty('last_name')
                    ? errorMessages.last_name
                    : ''
                    " :tip="tipALign" size="w-50" class="mrglt-8" />
              </BaseFormRow>
              <BaseFormRow :class="{
                'mb-0': isEmailExist,
              }" v-if="!userId" v-show="!isThirdParty">
                <BaseInput :id="`${widgetKey}_email`" v-model="form.email" placeholder="Your email"
                  :readonly="readOnly.includes('email') ? true : false" :error="errors.includes('email') ? true : false"
                  :error-message="errorMessages.hasOwnProperty('email')
                    ? errorMessages.email
                    : ''
                    " validation="email" :tip="tipALign" type="email" @blur="checkEmailExist" />
              </BaseFormRow>
              <p class="email-exists-error" v-if="isEmailExist">
                You already seem to have a Sellcodes account.
                <a v-if="isSelfHosted" data-target="#login" data-toggle="modal" class="sc-login-link flex"
                  data-dismiss="modal" data-backdrop="static" data-keyboard="false">
                  Please login
                </a>
                <a v-else class="sc-login-link flex" target="_blank"
                  :href="`${scBaseUrl}/${offer.secret_link}/?embLogin=1`">
                  Please login
                </a>
              </p>
            </div>
          </transition>
        </template>
        <span v-if="offer.options.length &&
          walletData.vatAmount &&
          walletData.vatAmount > 0
          " class="sc-buy-text"><i>An additional
            <span :id="`${widgetKey}_vat_amount`">{{ vat }}</span> USD will be
            added <br />(Value-Added Tax for
            {{ walletData.vatDetails.name }})</i></span>
        <span v-else class="sc-buy-text"><i>
            You’ll get charged {{ price }} USD
            <template v-if="walletData.vatAmount">
              (+{{ vat }} USD VAT)</template></i></span>
        <div class="sc-card-list" v-if="!isBalanceExists &&
          eligibleCards &&
          eligibleCards.length > 1
          ">
          <BaseFormRow>
            <h2>Which Credit Card do you want to use?</h2>
          </BaseFormRow>
          <div v-for="card in eligibleCards" :key="card.mp_creditcard_id" class="sc-card-list-item" :class="{
            active: card.mp_creditcard_id == selected_card.mp_creditcard_id,
          }" @click="selected_card = card">
            {{ `${card.cardProvider} ${card.last_four_digit}` }}
          </div>
        </div>
        <div v-if="!addNewCard" class="sc-new-card-wrap">
          <span class="sc-new-card">Want to enter a
            <a class="sc-new-card-link" href="javascript:" @click="addNewCard = true">new
              {{
                !isBalanceExists &&
                eligibleCards &&
                eligibleCards.length > 1
                ? "one"
                : "card"
              }} </a>?</span>
        </div>
        <BaseFormRow>
          <BaseButton variant="big-button" type="button" @click="submitFormQuickBuy">Yes, buy it!</BaseButton>
        </BaseFormRow>
        <transition enter-active-class="fadeInTop" leave-active-class="fadeOut" mode="out-in">
          <BaseFormRow v-if="showDiscount">
            <BaseInput :id="`${widgetKey}_discount_code`" v-model="form.discount_code" placeholder="Discount Code"
              size="w-75" :error="errors.includes('discount_code') ||
                errorMessages.hasOwnProperty('discount_code')
                ? true
                : false
                " :success="form.discount_code.length > 0 &&
    successMessages.hasOwnProperty('discount_code')
    " :success-message="successMessages.hasOwnProperty('discount_code')
    ? successMessages.discount_code
    : ''
    " :error-message="errorMessages.hasOwnProperty('discount_code')
    ? errorMessages.discount_code
    : ''
    " :is-vat="true" />
            <BaseButton size="w-25 h-40" variant="invert" type="button" :disabled="!form.discount_code.length"
              @click="checkVatNumber('dcode')" :loading="dCodeLoader">Apply</BaseButton>
          </BaseFormRow>
        </transition>
        <span v-if="walletData.purchased > 0" class="sc-buy-text"><i>Note: you already bought this item. To buy it
            again, click on the
            button above</i></span>
      </form>
      <form v-else-if="!isPaddleActive || form.pay_method == 1" class="sc-form" :class="{ fadeInBottom: show }"
        :key="`sc-form-${offer.secret}`" @submit.prevent="_submitForm" autocomplete="off"
        :style="`z-index:${highestZIndex}`">
        <a class="sc-back" @click="closeCheckout" href="javascript:"
          :style="`background-image:url(${scBaseUrl}/assets/images/Back.svg)`"></a>
        <div v-show="!hasParent" class="sc-price-info" :class="{ fadeInRight: show }">
          <div class="sc-price">
            ${{
              parseInt(price)
            }}<span class="small">.{{ price.split(".")[1] }}</span>
            <span v-if="vat > 0" class="sc-price-info-vat">+${{ vat }} VAT</span>
          </div>
        </div>

        <div class="sc-messages">
          <p class="sc-error-text" v-if="resultErrorMessage.length" v-html="resultErrorMessage"></p>
          <p class="sc-error-text" v-if="walletError" v-html="walletError"></p>
        </div>

        <div v-if="offer.options.length > 1" v-show="!isThirdParty && !hasParent" class="sc-product-options">
          <h2>Product option</h2>
          <BaseFormRow>
            <div class="sc-form-select-container sc-form-product-options">
              <div class="sc-select-box" :class="{
                'sc-select-has-error': errors.includes('optionId')
                  ? true
                  : false,
              }">
                <div @click="showProductOptions = !showProductOptions" class="sc-select-button brd"
                  ref="product-options-sc-selectbox" :class="{
                    'open-select-box': showProductOptions,
                  }" :style="`z-index:${highestZIndex + 17}`">
                  <div class="sc-selected-value">
                    <span>
                      {{
                        selectedProductOption.name ||
                        "Product Options" | TitleString
                      }}
                      <!-- <span>({{ selectedProductOption.price }} USD, {{ selectedProductOption.duration }} days)</span> -->
                    </span>
                  </div>
                  <div class="sc-select-chevrons">
                    <img :src="`${scBaseUrl}/assets/images/symbols-arrow.png`" alt />
                  </div>
                </div>
                <transition enter-active-class="fadeInFast" mode="out-in">
                  <div v-if="showProductOptions" v-closable="{
                    exclude: ['product-options-sc-selectbox'],
                    handler: 'onCloseProductOptions',
                  }" class="sc-options" :style="`z-index:${highestZIndex + 16}`">
                    <div class="sc-option" :class="{ 'sc-selected': option.ID == form.optionId }"
                      v-for="(option, index) in offer.options" :key="'product_options_' + index + '_' + option.name"
                      @click="form.optionId = option.ID">
                      <span class="sc-select-option-label">
                        {{ option.name | TitleString }}
                        <!-- <span>({{ option.price }} USD, {{ option.duration }} days)</span> -->
                      </span>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </BaseFormRow>
        </div>
        <p v-else></p>
        <template v-if="!isWalletSetup">
          <BaseFormRow>
            <div class="sc-form-select-container sc-user-type">
              <div class="sc-select-box" :class="{
                'sc-select-has-error': errors.includes('user_type')
                  ? true
                  : false,
              }">
                <label for="user_type">I'm a</label>

                <div @click="showUserTypes = !showUserTypes" class="sc-select-button brd" ref="user-type-sc-selectbox"
                  :class="{
                    'open-select-box': showUserTypes,
                  }">
                  <div class="sc-selected-value">
                    <span>{{ activeUserType }}</span>
                  </div>
                  <div class="sc-select-chevrons cursor-pointer">
                    <img :src="`${scBaseUrl}/assets/images/symbols-arrow.png`" alt />
                  </div>
                </div>
                <transition enter-active-class="fadeInFast" mode="out-in">
                  <div v-if="showUserTypes" v-closable="{
                    exclude: ['user-type-sc-selectbox'],
                    handler: 'onCloseUserType',
                  }" class="sc-options">
                    <div class="sc-option" :class="{ 'sc-selected': form.user_type == 1 }" key="user_type_1"
                      @click="form.user_type = 1">
                      <span class="sc-select-option-label">Private User</span>
                    </div>
                    <div class="sc-option" :class="{ 'sc-selected': form.user_type == 2 }" key="user_type_2"
                      @click="form.user_type = 2">
                      <span class="sc-select-option-label">Business</span>
                    </div>
                    <div class="sc-option" :class="{ 'sc-selected': form.user_type == 3 }" key="user_type_3"
                      @click="form.user_type = 3">
                      <span class="sc-select-option-label">Organization</span>
                    </div>
                    <div class="sc-option" :class="{ 'sc-selected': form.user_type == 4 }" key="user_type_4"
                      @click="form.user_type = 4">
                      <span class="sc-select-option-label">Sole trader</span>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <template v-if="!userId">
              <a v-if="isSelfHosted && !iframe" data-target="#login" data-toggle="modal" class="sc-login-link flex"
                data-dismiss="modal" data-backdrop="static" data-keyboard="false" @click="closeCheckout">
                Already a user?<span class="has-tooltip">
                  <img :src="`${scBaseUrl}/assets/images/info.svg`" alt="info" />
                  <BaseToolTip
                    text="This product is sold on Sellcodes.com. If you already have a Sellcodes account, please click to login."
                    class="tooltip-text" tip="bottom-right"></BaseToolTip>
                </span>
              </a>
              <a v-else class="sc-login-link flex" target="_blank"
                :href="`${scBaseUrl}/${offer.secret_link}/?embLogin=1`">
                Already a user?<span class="has-tooltip">
                  <img :src="`${scBaseUrl}/assets/images/info.svg`" alt="info" />
                  <BaseToolTip
                    text="This product is sold on Sellcodes.com. If you already have a Sellcodes account, please click to login."
                    class="tooltip-text" tip="bottom-right"></BaseToolTip>
                </span>
              </a>
            </template>
          </BaseFormRow>
          <transition enter-active-class="fadeInTop" leave-active-class="fadeOut" mode="out-in">
            <div v-if="[2, 3, 4].includes(form.user_type)" key="businessUserBlock" id="businessUserBlock">
              <BaseFormRow>
                <BaseInput :id="`${widgetKey}_business_name`" v-model="form.business_name" placeholder="Business name"
                  :error="errors.includes('business_name') ? true : false" :error-message="errorMessages.hasOwnProperty('business_name')
                    ? errorMessages.business_name
                    : ''
                    " :required="true" class="mrgrt-8" />
                <BaseSelect :id="`${widgetKey}_residence_business`" v-model="form.residence_business"
                  placeholder="Business residence" :options="countries" option-label="name" option-value="alpha_2"
                  option-input="alpha_3" option-sub-label="alpha_3" label="Business residence"
                  :error="errors.includes('residence_business') ? true : false" :error-message="errorMessages.hasOwnProperty('residence_business')
                    ? errorMessages.residence_business
                    : ''
                    " :required="true" class="mrglt-8" />
              </BaseFormRow>
              <BaseFormRow v-if="isEU && !showEUVat">
                <a href="javascript:" @click="showEUVat = !showEUVat" class="vat-toggle-link">Have an EU VAT number?</a>
              </BaseFormRow>

              <transition enter-active-class="fadeInTop" leave-active-class="fadeOut" mode="out-in">
                <template v-if="isEU && showEUVat">
                  <BaseFormRow>
                    <BaseInput :id="`${widgetKey}_eu_vat_number`" v-model="form.eu_vat_number" placeholder="EU VAT number"
                      :error="form.eu_vat_number.length &&
                        (errors.includes('eu_vat_number') ||
                          errorMessages.hasOwnProperty('eu_vat_number'))
                        ? true
                        : false
                        " :success="form.eu_vat_valid == 1 && form.eu_vat_number.length
    " :success-message="successMessages.hasOwnProperty('eu_vat_number')
    ? successMessages.eu_vat_number
    : ''
    " :error-message="errorMessages.hasOwnProperty('eu_vat_number')
    ? errorMessages.eu_vat_number
    : ''
    " size="w-75" :is-vat="true" />
                    <BaseButton size="w-25 h-40" variant="invert" type="button" @click="checkVatNumber('vat')"
                      :loading="vatLoader">Check</BaseButton>
                  </BaseFormRow>
                </template>
              </transition>
              <BaseFormRow>
                <h2>Legal representative</h2>
              </BaseFormRow>
              <BaseFormRow>
                <BaseInput :id="`${widgetKey}_first_name_b`" v-model="form.first_name" placeholder="First name"
                  size="w-50" :error="errors.includes('first_name') ? true : false" :error-message="errorMessages.hasOwnProperty('first_name')
                    ? errorMessages.first_name
                    : ''
                    " :required="true" class="mrgrt-8" />
                <BaseInput :id="`${widgetKey}_last_name_b`" v-model="form.last_name" placeholder="Last name"
                  :error="errors.includes('last_name') ? true : false" :error-message="errorMessages.hasOwnProperty('last_name')
                    ? errorMessages.last_name
                    : ''
                    " :tip="tipALign" :required="true" size="w-50" class="mrglt-8" />
              </BaseFormRow>

              <BaseFormRow :class="{
                'mb-0': isEmailExist,
              }" v-if="!userId" v-show="!isThirdParty">
                <BaseInput :id="`${widgetKey}_email_b`" v-model="form.email" placeholder="Your email"
                  :readonly="readOnly.includes('email') ? true : false" :error="errors.includes('email') ? true : false"
                  :error-message="errorMessages.hasOwnProperty('email')
                    ? errorMessages.email
                    : ''
                    " validation="email" :tip="tipALign" type="email" @blur="checkEmailExist" />
              </BaseFormRow>
              <p class="email-exists-error" v-if="isEmailExist">
                You already seem to have a Sellcodes account.
                <a v-if="isSelfHosted" data-target="#login" data-toggle="modal" class="sc-login-link flex"
                  data-dismiss="modal" data-backdrop="static" data-keyboard="false">
                  Please login
                </a>
                <a v-else class="sc-login-link flex" target="_blank"
                  :href="`${scBaseUrl}/${offer.secret_link}/?embLogin=1`">
                  Please login
                </a>
              </p>
            </div>
            <div v-else key="privateUserBlock">
              <BaseFormRow>
                <BaseInput :id="`${widgetKey}_first_name`" v-model="form.first_name" placeholder="First name" size="w-50"
                  :required="true" :error="errors.includes('first_name') ? true : false" :error-message="errorMessages.hasOwnProperty('first_name')
                    ? errorMessages.first_name
                    : ''
                    " class="mrgrt-8" />
                <BaseInput :id="`${widgetKey}_last_name`" v-model="form.last_name" placeholder="Last name"
                  :required="true" :error="errors.includes('last_name') ? true : false" :error-message="errorMessages.hasOwnProperty('last_name')
                    ? errorMessages.last_name
                    : ''
                    " :tip="tipALign" size="w-50" class="mrglt-8" />
              </BaseFormRow>
              <BaseFormRow :class="{
                'mb-0': isEmailExist,
              }" v-if="!userId" v-show="!isThirdParty">
                <BaseInput :id="`${widgetKey}_email`" v-model="form.email" placeholder="Your email"
                  :readonly="readOnly.includes('email') ? true : false" :error="errors.includes('email') ? true : false"
                  :error-message="errorMessages.hasOwnProperty('email')
                    ? errorMessages.email
                    : ''
                    " validation="email" :tip="tipALign" type="email" @blur="checkEmailExist" />
              </BaseFormRow>
              <p class="email-exists-error" v-if="isEmailExist">
                You already seem to have a Sellcodes account.
                <a v-if="isSelfHosted" data-target="#login" data-toggle="modal" class="sc-login-link flex"
                  data-dismiss="modal" data-backdrop="static" data-keyboard="false">
                  Please login
                </a>
                <a v-else class="sc-login-link flex" target="_blank"
                  :href="`${scBaseUrl}/${offer.secret_link}/?embLogin=1`">
                  Please login
                </a>
              </p>
            </div>
          </transition>
        </template>

        <BaseFormRow class="sc-payment-method-header">
          <div class="w-50 sc-tab-credit-card" @click="togglePayMethod(0)">
            Credit card
          </div>
          <div v-show="!hasParent && availableProviders.includes('PAYPAL')" class="w-50 sc-tab-paypal"
            @click="togglePayMethod(1)">
            or pay with
            <span>
              <img class="sc-purchase-modal__paypal-method-img" :src="`${scBaseUrl}/assets/images/paypal_method.png`"
                alt="paypal" />
            </span>
          </div>
        </BaseFormRow>
        <!-- <transition enter-active-class="fadeInTop" mode="out-in"> -->
        <p class="sc-error-text"
          v-if="!form.pay_method && !isSecondaryCheckout && !availableProviders.includes('PAYPAL')">We're currently facing
          issues with our payment system. Please contact us at support@sellcodes.com so that we can arrange alternative
          ways of payments, or notify you when the issue is corrected. Thank you!</p>
        <p class="sc-error-text" v-else-if="!form.pay_method && !isSecondaryCheckout">Our Credit Card payment processor is
          facing issues. Please pay via PayPal, or contact us at support@sellcodes.com so that we can arrange alternative
          ways of payments, or notify you when the issue is corrected. Thank you!</p>
        <div v-if="(false && !form.pay_method && !isSecondaryCheckout)" class="sc-credit-card" :class="errors.includes('credit_card_number') ||
          errors.includes('credit_card_expiry') ||
          errors.includes('credit_card_cvc')
          ? 'has-error'
          : ''
          ">
          <div class="sc-credit-card-number" :class="{
            'has-tooltip': errorMessages.hasOwnProperty('credit_card_number'),
          }">
            <input :id="`${widgetKey}_credit_card_number`" class="sc-credit-card-input" autocomplete="cc-number"
              placeholder="Card number" v-model="form.credit_card_number" />
            <transition enter-active-class="fadeIn" leave-active-class="fadeOut" mode="out-in">
              <div v-if="errorMessages.hasOwnProperty('credit_card_number')" class="input-error">
                <div class="has-tooltip">
                  <img :src="`${scBaseUrl}/assets/images/Error.svg`" alt="Error" />
                  <BaseToolTip :ref="`tooltip-error-${form.credit_card_number}`" v-if="errorMessages.credit_card_number"
                    class="tooltip-input" tip="bottom-left">{{ errorMessages.credit_card_number }}</BaseToolTip>
                </div>
              </div>
            </transition>
          </div>
          <BaseInput :id="`${widgetKey}_${randomKey}_credit_card_expiry`" v-model="form.credit_card_expiry"
            class-name="sc-credit-card-expiry" placeholder="MM/YY"
            :error="errors.includes('credit_card_expiry') ? true : false" :error-message="errorMessages.hasOwnProperty('credit_card_expiry')
              ? errorMessages.credit_card_expiry
              : ''
              " :required="true" />
          <BaseInput :id="`${widgetKey}_${randomKey}_credit_card_cvc`" v-model="form.credit_card_cvc" placeholder="CVC"
            class-name="sc-credit-card-cvc" :error="errors.includes('credit_card_cvc') ? true : false" :error-message="errorMessages.hasOwnProperty('credit_card_cvc')
              ? errorMessages.credit_card_cvc
              : ''
              " :required="true" />
        </div>
        <!-- </transition> -->
        <div v-show="isSecondaryCheckout" :id="`${formRef}card-element`" class="sc-stripe-card-element" :class="errors.includes('credit_card_number') ||
          errors.includes('credit_card_expiry') ||
          errors.includes('credit_card_cvc')
          ? 'has-error'
          : ''
          ">
          <!-- A Stripe Element will be inserted here. -->
          <div :id="`${formRef}cardNumber`" class="sc-stripe-card-number-element"></div>
          <div :id="`${formRef}cardExpiry`" class="sc-stripe-card-expiry-element"></div>
          <div :id="`${formRef}cardCvc`" class="sc-stripe-card-cvc-element"></div>
        </div>
        <template v-if="!isWalletSetup">
          <!-- <BaseFormRow class="sc-referral-row">
            <p>
              Information for earning referral commissions
              <span class="has-tooltip">
                <img :src="`${scBaseUrl}/assets/images/info.svg`" alt="info" />
                <BaseToolTip
                  text="If you like the product you're buying, you can refer it to friends and earn referral commissions (40% of the purchase price). Those commissions will be stored in your digital wallet which is kind of a «mini bank account» so we are <a href='https://sellcodes.com/support/wallet' target='_blank'>legally required</a> to ask for this information. Obviously, we'll treat it <a href='https://sellcodes.com/privacy' target='_blank'>highly confidentially</a>."
                  class="tooltip-text"
                  tip="bottom-right"
                  size="lg"
                ></BaseToolTip>
              </span>
            </p>
          </BaseFormRow> -->
          <!-- <BaseFormRow class="sc-referral-row">
            <BaseCheckbox :id="`${widgetKey}_is_referral`" v-model="form.is_referral"
              label="I want to earn referral commissions"
              info-tooltip="If you like the product you're buying, you can refer it to friends and earn referral commissions (40% of the purchase price). Those commissions will be stored in your digital wallet which is kind of a «mini bank account» so we are <a href='https://sellcodes.com/support/wallet' target='_blank'>legally required</a> to ask for this information. Obviously, we'll treat it <a href='https://sellcodes.com/privacy' target='_blank'>highly confidentially</a>."
              tooltip-size="lg" />
          </BaseFormRow> -->
          <BaseFormRow class="sc-referral-row" v-show="true">
            <p>
              Information for earning referral commissions
              <span class="has-tooltip">
                <img :src="`${scBaseUrl}/assets/images/info.svg`" alt="info" />
                <BaseToolTip
                  text="If you like the product you're buying, you can refer it to friends and earn referral commissions (40% of the purchase price). Those commissions will be stored in your digital wallet which is kind of a «mini bank account» so we are <a href='https://sellcodes.com/support/wallet' target='_blank'>legally required</a> to ask for this information. Obviously, we'll treat it <a href='https://sellcodes.com/privacy' target='_blank'>highly confidentially</a>."
                  class="tooltip-text" tip="bottom-right" size="lg"></BaseToolTip>
              </span>
            </p>
          </BaseFormRow>
          <transition enter-active-class="fadeInTop" leave-active-class="fadeOut" mode="out-in">
            <div v-if="form.is_referral">
              <template v-if="[2].includes(form.user_type)">
                <BaseFormRow>
                  <h2>Company number</h2>
                </BaseFormRow>
                <BaseFormRow>
                  <BaseInput :id="`${widgetKey}_company_number`" v-model="form.company_number" validation="alphanumeric"
                    placeholder="Company number" :error="errors.includes('company_number') ? true : false" :error-message="errorMessages.hasOwnProperty('company_number')
                      ? errorMessages.company_number
                      : ''
                      " :required="true" class="mrgrt-8" />
                </BaseFormRow>
              </template>
              <template v-if="form.user_type > 1">
                <BaseFormRow>
                  <h2>Headquarter address</h2>
                </BaseFormRow>
                <BaseFormRow>
                  <BaseInput :id="`${widgetKey}_address1`" v-model="form.address1" placeholder="Address line 1"
                    :error="errors.includes('address1') ? true : false" :error-message="errorMessages.hasOwnProperty('address1')
                      ? errorMessages.address1
                      : ''
                      " :required="true" class="mrgrt-8" />
                  <BaseInput :id="`${widgetKey}_address2`" v-model="form.address2" placeholder="Address line 2"
                    :error="errors.includes('address2') ? true : false" :error-message="errorMessages.hasOwnProperty('address2')
                      ? errorMessages.address2
                      : ''
                      " :required="true" />
                </BaseFormRow>
                <BaseFormRow>
                  <BaseInput :id="`${widgetKey}_city`" v-model="form.city" placeholder="City"
                    :error="errors.includes('city') ? true : false" :error-message="errorMessages.hasOwnProperty('city')
                      ? errorMessages.city
                      : ''
                      " :required="true" />
                  <BaseInput :id="`${widgetKey}_state`" v-model="form.state" placeholder="State"
                    :error="errors.includes('state') ? true : false" :error-message="errorMessages.hasOwnProperty('state')
                      ? errorMessages.state
                      : ''
                      " :required="true" class="mrglt-8" />
                  <BaseInput :id="`${widgetKey}_post_code`" v-model="form.post_code" placeholder="Postcode"
                    :error="errors.includes('post_code') ? true : false" :error-message="errorMessages.hasOwnProperty('post_code')
                      ? errorMessages.post_code
                      : ''
                      " :required="true" class="mrglt-8" />
                </BaseFormRow>
              </template>

              <BaseFormRow class="sc-referral-box">
                <BaseDatePicker :id="`${widgetKey}_dob`" v-model="form.dob" label="Birthday" placeholder="Date of birth"
                  :error="errors.includes('dob') ? true : false" :error-message="errorMessages.hasOwnProperty('dob') ? errorMessages.dob : ''
                    " />
                <BaseSelect :id="`${widgetKey}_residence`" v-model="form.residence" placeholder="Residence"
                  :options="countries" option-label="name" option-value="alpha_2" option-input="alpha_3"
                  option-sub-label="alpha_3" label="Residence" :error="errors.includes('residence') ? true : false"
                  :error-message="errorMessages.hasOwnProperty('residence')
                    ? errorMessages.residence
                    : ''
                    " :required="true" class="mrglt-8" :scroll-height="-220" :scroll-multiplier="6" />
                <BaseSelect :id="`${widgetKey}_nationality`" v-model="form.nationality" placeholder="Nationality"
                  :options="countries" option-label="nationality" option-value="alpha_2" option-input="alpha_3"
                  option-sub-label="alpha_3" label="Nationality" :error="errors.includes('nationality') ? true : false"
                  :error-message="errorMessages.hasOwnProperty('nationality')
                    ? errorMessages.nationality
                    : ''
                    " :required="true" class="mrglt-8" />
              </BaseFormRow>
            </div>
          </transition>
        </template>

        <p class="mrgt-10" v-else></p>
        <transition enter-active-class="fadeInTop" leave-active-class="fadeOut" mode="out-in">
          <BaseFormRow v-if="showDiscount">
            <BaseInput :id="`${widgetKey}_discount_code`" v-model="form.discount_code" placeholder="Discount Code"
              size="w-75" :error="errors.includes('discount_code') ||
                errorMessages.hasOwnProperty('discount_code')
                ? true
                : false
                " :success="form.discount_code.length > 0 &&
    successMessages.hasOwnProperty('discount_code')
    " :success-message="successMessages.hasOwnProperty('discount_code')
    ? successMessages.discount_code
    : ''
    " :error-message="errorMessages.hasOwnProperty('discount_code')
    ? errorMessages.discount_code
    : ''
    " :is-vat="true" />
            <BaseButton size="w-25 h-40" variant="invert" type="button" :disabled="!form.discount_code.length"
              @click="checkVatNumber('dcode')" :loading="dCodeLoader">Apply</BaseButton>
          </BaseFormRow>
        </transition>
        <BaseFormRow v-show="!hasParent">
          <div class="sc-buy-text" v-if="this.discount.status != 1">
            You are buying "<span v-html="offer.title"></span>" and will be
            charged ${{ price }}<span v-if="vat > 0"> (+ ${{ vat }} VAT)</span>
          </div>
          <div class="sc-buy-text" v-else>
            You are buying "{{ offer.title }}" and will be charged
            <span class="original-price">${{
              originalPrice
            }}<span v-if="originalPriceVat > 0">&nbsp;(+ ${{ originalPriceVat }} VAT)</span></span>
            ${{ price }}<span v-if="vat > 0">&nbsp;(+ ${{ vat }} VAT)</span>
          </div>
        </BaseFormRow>
        <BaseFormRow class="relative mrgbt-0">
          <BaseButton variant="big-button" type="button" @click="_submitForm">{{
            payButtonText
          }}</BaseButton>
        </BaseFormRow>
        <p class="sc-faq-wrap" v-if="offer.faq && offer.faq.status">
          <Faq :faq="offer.faq" />
        </p>
      </form>
    </div>

    <div class="sc-form-footer" key="`sc-form-footer-${offer.secret}`" :style="`z-index:${highestZIndex}`">
      <PaySuccessComponent :showSuccess="resultMessage.length" :resultMessage="resultMessage" />
      <BaseFormRow>
        <div class="sc-buy-info">
          <div class="has-tooltip">
            <a class="license_display sc-popup__title" v-html="licenseText"></a>
            <BaseToolTip :show="licenceTextTooltipShow" v-if="licenceTextTooltip" :text="licenceTextTooltip"
              class="tooltip-text" tip="bottom-right"></BaseToolTip>
          </div>
          <span class="sc-separator">|</span>
          <div class="has-tooltip">
            <a class="pricing_display sc-popup__title">{{
              isRecurring ? "Recurring pricing" : "One-time charge"
            }}</a>
            <BaseToolTip :show="chargeTooltipShow" v-if="chargeTooltip" class="tooltip-text" tip="bottom-right">
              {{ chargeTooltip }}
            </BaseToolTip>
          </div>
          <template v-if="this.form.pay_method != ''">
            <span class="sc-separator">|</span>
            <div class="has-tooltip">
              <a class="sc-popup" @click="toggleDiscountBox">D-codes</a>
              <BaseToolTip :show="dcodeTextTooltipShow" v-if="dcodeTextTooltip" :text="dcodeTextTooltip"
                class="tooltip-text" tip="bottom-right"></BaseToolTip>
            </div>
          </template>
        </div>
      </BaseFormRow>
      <BaseFormRow>
        <div class="sc-secure-info" key="`sc-form-footer-${offer.secret}`">
          <img :src="`${scBaseUrl}/assets/images/Secure.svg`" alt /> SECURE
          Checkout using SSL data encryption
        </div>
      </BaseFormRow>
      <BaseFormRow>
        <p>
          Sold via & Fulfilled by
          <a :href="scBaseUrl" target="_blank">Sellcodes</a>, an authorised
          <br v-if="windowWidth < 376" />marketplace for
          <br v-if="windowWidth > 375" />software, in collabaration with
          <br v-if="windowWidth < 376" />payment provider Mangopay.
        </p>
      </BaseFormRow>
      <BaseFormRow>
        <p class="mrgt-10 mrgbt-20">
          All data is treated highly confidentially, see our
          <a :href="`${scBaseUrl}/privacy`" target="_blank">
            Privacy
            <br v-if="windowWidth < 376" />Policy
          </a>
          and
          <br v-if="windowWidth > 375" />
          <a :href="`${scBaseUrl}/terms`" target="_blank">Terms of Use</a>
          to which you agree to
          <br v-if="windowWidth < 376" />with your purchase.
        </p>
      </BaseFormRow>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Faq from "./FaqComponent";
import PaySuccessComponent from "./PaySuccessComponent";
import PriceComponent from "./common/PriceComponent";
// import $checkout from "ipsp-js-sdk";
// import { loadStripe } from "@stripe/stripe-js";

const stripeKey = process.env.STRIPE_KEY;
const paddleVendorId = process.env.PADDLE_VENDOR_ID;
const nodeEnv = process.env.NODE_ENV || 'sandbox';



let elements = null;
export default {
  components: {
    Datepicker,
    Faq,
    PaySuccessComponent,
    PriceComponent
  },
  props: {
    offer: { type: Object, required: true },
    parent: { type: String, required: false, default: false },
    show: {
      type: Boolean,
      default: false,
    },
    dcode: {
      type: String,
      default: "",
    },
    offerOption: {
      type: String,
      default: "",
    },
    userId: {
      type: String,
      default: "",
    },
    username: {
      type: String,
      default: "",
    },
    userType: {
      type: [String, Number],
      default: "",
    },
    email: {
      type: String,
      default: "",
    },
    widgetKey: {
      type: [String, Number],
      default: "",
    },
    iframe: {
      type: [String, Number],
      default: 0,
    },
    payMethod: {
      type: [Number, String],
      default: 0,
    },
    hostname: {
      type: String,
      default: "",
    },
    noRedirect: {
      type: String,
      default: "false",
    },
    redirectUrl: {
      type: String,
      default: "",
    },
    callbackUrl: {
      type: String,
      default: "",
    },
    formRef: {
      type: String,
      default: "",
    },
    licenseKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isPaddleOpen: false,
      selected_card: "",
      addNewCard: false,
      isEmailExist: false,
      vatLoader: false,
      dCodeLoader: false,
      clientData: {},
      showDiscount: false,
      showProductOptions: false,
      showUserTypes: false,
      discount: {},
      country: null,
      countries: [],
      vatRate: 0,
      showEUVat: false,
      form: {
        offer_id: null,
        user_type: 1,
        business_name: "",
        residence_business: "",
        first_name: "",
        last_name: "",
        email: "",
        is_referral: 1,
        dob: "",
        residence: "",
        nationality: "",
        pay_method: 0,
        optionId: "",
        eu_vat_number: "",
        eu_vat_valid: 0,
        discount_code: "",
        credit_card_number: "", //Blank
        // credit_card_number: "4444555566661111", //3D Secure Approve
        // credit_card_number: "4444111166665555",//3D Secure Decline
        // credit_card_number: "4444555511116666", //Non 3D Secure Approve
        // credit_card_number: "4444111155556666",//Non 3D Secure Decline
        credit_card_expiry: "",
        credit_card_cvc: "",
        payment_token: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        post_code: "",
        company_number: "",
      },
      randomKey: Math.random().toString(16),
      checkoutKey: Math.random().toString(16),
      errors: [],
      readOnly: [],
      errorMessages: {},
      successMessages: {},
      resultMessage: "",
      resultErrorMessage: "",
      dcodeTextTooltipShow: false,
      licenceTextTooltipShow: false,
      chargeTooltipShow: false,
      walletData: {},
      fondyCheckout: "",
      purchaseCheckInterval: "",
      reportId: "",
      secure_status: false,
      force_secondary: false,
      closeCheckInterval: null,
      preSelectedOption: null,
      stripe: {
        client: null,
        card: null,
        cvc: null,
        exp: null,
      },
      paddle_init: false,
      paddlePriceData: "",
      responseRedirectURL: "",
      customHeight: "",
    };
  },
  computed: {
    hasParent() {
      if (this.parent && this.parent.length) {
        return true;
      }
      return false;
    },
    isThirdParty() {
      return (
        this.noRedirect == "true" &&
        this.preSelectedOption &&
        this.email.length &&
        this.validateEmail(this.email)
      );
    },
    isWalletSetup() {
      if (!this.userId) {
        return false;
      }
      if (!this.walletData) {
        return false;
      }
      if (!this.walletData.wallet_setup) {
        return false;
      }
      if (this.walletData.wallet_setup == "Yes") {
        return true;
      }
      return false;
    },
    eligibleCards() {
      return this.walletData.cards.filter(
        (card) => card.cardProvider != "unknown"
      );
    },
    showQuickPurchase() {
      if (this.addNewCard) {
        return false;
      }
      return this.walletData && this.walletData.wallet_setup == "Yes";
    },
    walletError() {
      return this.walletData && this.walletData.error == "authentication"
        ? this.walletData.message
        : false;
    },
    selectedCountry() {
      if (this.form.user_type == 1) {
        return this.countries.find(
          (country) => country.alpha_2 == this.form.residence
        );
      }
      return this.countries.find(
        (country) => country.alpha_2 == this.form.residence_business
      );
    },
    isEU() {
      return (
        this.selectedCountry &&
        this.selectedCountry.dependent_territories == "EU"
      );
    },
    isRecurring() {
      return parseInt(this.selectedProductOption.pricing_type);
    },
    originalPrice() {
      return this.selectedProductOption.price;
    },
    price() {

      if (this.isPaddleOpen && this.paddlePriceData && this.paddlePriceData.subtotal) {
        return parseFloat(this.paddlePriceData.subtotal - (this.paddlePriceData.discount || 0)).toFixed(2);
      }

      let price =
        this.discount && this.discount.status
          ? this.discount.price
          : this.selectedProductOption
            ? this.selectedProductOption.price
            : 0;
      return parseFloat(price).toFixed(2);
    },
    renewal_discount() {
      return this.discount && this.discount.discount_is_renewal != "0"
        ? this.discount.discount_price
        : this.offer.discount_renewal_value
          ? this.offer.discount_renewal_value
          : 0;
    },
    renewal_price() {
      if (!this.isRecurring || !this.renewal_discount) {
        return this.discount.renewal_price || this.price;
      } else if (this.isRecurring && this.discount.renewal_price) {
        return parseFloat(
          this.discount.renewal_price
        )
      }
      return parseFloat(
        this.originalPrice - this.originalPrice * (this.renewal_discount / 100)
      );
    },
    vat() {
      if (this.form.eu_vat_valid) {
        return 0;
      }

      if (this.isPaddleOpen && this.paddlePriceData && this.paddlePriceData.tax) {
        return parseFloat(this.paddlePriceData.tax).toFixed(2);
      }

      return (
        this.discount && this.discount.price
          ? this.discount.vatAmount
          : this.vatRate
            ? (this.vatRate / 100) * this.price
            : 0
      ).toFixed(2);
    },
    originalPriceVat() {
      let vatRate = this.vatRate ? this.vatRate : (this.vat / this.price) * 100;
      return (vatRate ? (vatRate / 100) * this.originalPrice : 0).toFixed(2);
    },
    payButtonText() {
      return this.form.pay_method ? "Pay via PayPal" : "Pay";
    },
    selectedProductOption() {
      return this.offer.options.find(
        (option) => option.ID == this.form.optionId
      );
    },
    licenseText() {
      let licenseType = parseInt(this.selectedProductOption.license);
      let licenseText = "";
      switch (licenseType) {
        case 1:
          licenseText = "Own use only (<u>no end product</u>)";
          break;

        case 2:
          licenseText = "1 <u>free</u> end product";
          break;

        case 3:
          licenseText = "1 <u>paid</u> end product";
          break;

        case 4:
          licenseText = "Full transfer";
          break;

        case 5:
          licenseText = "Custom";
          break;

        case 6:
          licenseText = "Membership";
          break;

        default:
          licenseText = "<u>none</u>";
          break;
      }
      return licenseText;
    },
    licenceTextTooltip() {
      return `You’re acquiring the item under the <span>«${this.licenseText}»</span> license. <a href="${this.scBaseUrl}/licenses" target="_blank">Learn more about licenses</a>`;
    },
    dcodeTextTooltip() {
      return `Click to enter a discount code.`;
    },
    chargeTooltip() {
      let toolTip =
        "This is a one-time charge, i.e. you will not get charged for it again.";
      if (this.isRecurring) {
        let renewal_price = Math.round(this.renewal_price * 100) / 100;
        let discountText =
          parseFloat(this.renewal_discount) > 0
            ? ` which includes a ${this.renewal_discount}% renewal discount.`
            : ".";
        toolTip = `The license duration is ${this.selectedProductOption.duration} days, after which it will be automatically renewed for $${renewal_price}${discountText} You can cancel it anytime.`;
      }
      return toolTip;
    },
    activeUserType() {
      switch (this.form.user_type) {
        case 2:
          return "Business";
          break;
        case 3:
          return "Organization";
          break;
        case 4:
          return "Sole trader";
          break;
        default:
          return "Private User";
          break;
      }
    },
    cheapestProductOption() {
      return this.offer.options.reduce(function (res, obj) {
        return parseFloat(obj.price) < parseFloat(res.price) ? obj : res;
      });
    },
    isSecondaryCheckout() {
      if (
        !this.form.pay_method &&
        (this.force_secondary || !this.form.is_referral || this.isEU)
      ) {
        // Disable secondary checkout for now
        return false;
        // return true;
      }
      return false;
    },
    isBalanceExists() {
      if (!this.walletData) {
        return false;
      }
      if (!this.walletData.wallet_balance_amount) {
        return false;
      }

      let wallet_balance_amount = parseFloat(this.walletData.wallet_balance_amount).toFixed(2);
      let total = (parseFloat(this.price) + parseFloat(this.vat)).toFixed(2);
      return (wallet_balance_amount >= total)
    },
    availableProviders() {
      let providers = ['PAYPAL', 'STRIPE', 'MANGOPAY', 'PADDLE'];
      if (!this.offer) {
        return providers;
      }
      if (this.offer.dpg.length == 0) {
        return providers;
      }
      return providers.filter(item => !Object.values(this.offer.dpg).includes(item));
    },
    isPaddleActive() {

      if (!this.selectedProductOption) {
        return false;
      }

      if (this.availableProviders && !this.availableProviders.includes('PADDLE')) {
        return false;
      }

      if (this.isBalanceExists) {
        return false;
      }

      if (this.selectedProductOption.paddle_product_id && this.selectedProductOption.paddle_product_id.length) {
        return true;
      }



      return false;
    }
  },
  watch: {
    selectedProductOption(val) {
      if (val.paddle_product_id && val.paddle_product_id.length) {
        this.form.payment_method = "";
        this.initPaddle();
      }
    },
    showQuickPurchase(val) {
      if (!val) {
        // this.initStripe();
      }
    },
    scLoadedScripts() {
      if (this.scLoadedScripts.includes("mangoPay")) {
        // mangoPay.cardRegistration.clientId = "rupeshmonad";
        mangoPay.cardRegistration.baseURL = "https://api.sandbox.mangopay.com";
      }
    },
    "form.user_type"() {
      this.showUserTypes = false;
      if ([2, 3, 4].includes(this.form.user_type)) {
        for (let option of this.offer.options) {
          if (option.switch_business == "1") {
            // console.log(option.ID);
            this.form.optionId = option.ID;
          }
        }
      }
    },
    "form.optionId"() {
      this.discount = {};
      this.showProductOptions = false;
      this.checkVatNumber();
    },
    isEU(val) {
      this.discount = {};
      // Force Stripe for All Countries
      // this.force_secondary = true;
      // Disable Stripe for All Countries
      this.force_secondary = false;


      /*
      if (val) {
        this.force_secondary = true;
      } else {
        this.force_secondary = false;
      }*/

      this.checkVatNumber();
    },
    selectedCountry(val) {
      if (val.primary_status == 0) {
        //this.force_secondary = true;
        // Disable Stripe for All Countries
        this.force_secondary = false;
      }
    },
    "form.eu_vat_number"() {
      this.eu_vat_valid = 0;
    },
    "form.credit_card_number"() {
      let value = this.form.credit_card_number;

      var v = value
        .replace(/\D/g, "")
        .replace(/\s+/g, "")
        .replace(/[^0-9]/gi, "");

      var matches = v.match(/\d{4,16}/g);
      var match = (matches && matches[0]) || "";
      var parts = [];

      for (var i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
      }

      if (parts.length) {
        this.form.credit_card_number = parts.join("-");
      } else {
        this.form.credit_card_number = value;
      }
    },
    "form.credit_card_cvc"(newVal, old) {
      if (newVal.length > 4) {
        this.form.credit_card_cvc = old;
        this.randomKey = Math.random().toString(16);
      }
    },
    "form.credit_card_expiry"(newVal, old) {
      if (newVal.length > 5) {
        this.form.credit_card_expiry = old;
      } else {
        let value = this.form.credit_card_expiry;
        var v = value
          .replace(/\D/g, "")
          .replace(/\s+/g, "")
          .replace(/[^0-9]/gi, "");
        if (v.length > 3) {
          this.form.credit_card_expiry = v
            .substring(0, 4)
            .match(/.{1,2}/g)
            .join("/");
        }
      }
      this.randomKey = Math.random().toString(16);
    },
    show() {
      if (this.show) {
        this.reportSubmit();
        return true;
      }
    },
    payMethod() {
      this.togglePayMethod(this.payMethod);
    },
  },
  created() {
    this.form.offer_id = this.offer.ID;
    if (this.offer.options.length) {
      if (this.offerOption) {
        this.preSelectedOption = this.offer.options.find(
          (option) =>
            option.ID == this.offerOption ||
            option.name == this.offerOption ||
            option.secret == this.offerOption
        );
        if (this.preSelectedOption) {
          this.form.optionId = this.preSelectedOption.ID;
        }
        if (!this.form.optionId) {
          this.form.optionId = this.cheapestProductOption.ID;
        }
      } else if (this.offer.default_option_id){
        // get default option
        let defaultOption = this.offer.options.find(
          (option) => option.ID == this.offer.default_option_id
        );
        if (defaultOption) {
          this.form.optionId = this.offer.default_option_id;
        } 
        else {
          this.form.optionId = this.cheapestProductOption.ID;
        }
      }       
      else {
        this.form.optionId = this.cheapestProductOption.ID;
      }
    }
    if (this.email && this.email.length && this.validateEmail(this.email)) {
      this.form.email = this.email.replace(/ /g, "+");
      this.readOnly.push("email");
    }
    if (this.isSelfHosted) {
      this.getOptions();
    }
    if (this.parent && this.parent.length) {
      this.addNewCard = true;
    }
  },
  mounted() {
    this.getClientData();
    if (this.isSelfHosted && this.userId) {
      this.checkWallet();
    }

    
    //ipsp-modal-wrapper
    // this.observeDomChange();

    //Disable Stripe Loader
    // this.$nextTick(() => {
      //   this.initStripe();
      // });
      
      // this.$nextTick(() => {
        //   this.initPaddle();
        // });
        
    this.$nextTick(() => {
       this.$emit("loader", false);
    });
  },
  methods: {
    closeCheckout() {
      if (this.selectedProductOption.paddle_product_id && this.selectedProductOption.paddle_product_id.length) {
        this.form.pay_method = '';
      }
      this.$emit("loader", false);
      this.$emit('close');
    },
    setPayType(type) {
      if (!this.form.email) {
        this.errors.push('email');
        this.errorMessages['email'] = "Please enter a valid email address.";
        return;
      }
      this.form.pay_method = type;
      setTimeout(() => {
        if (!type && this.isPaddleActive) {
          this.paddleCheckout();
        }
      }, 500);
    },
    async loadPaddleScript() {
      if (!window.Paddle) {
        const script = document.createElement("script");
        // script.src = "https://cdn.paddle.com/paddle/paddle.js";
        script.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
        script.async = true;
        document.head.appendChild(script);

        await new Promise((resolve, reject) => {
          script.onload = resolve;
          script.onerror = reject;
        });
      }
    },
    async initPaddle() {
      await this.loadPaddleScript();
      let email = this.form.email;
      let pwCustomer = null;
      if (email) {
        pwCustomer = {
          email: email,
        };
      }
      console.log("Paddle Init paddleVendorId", paddleVendorId);
      console.log("Paddle Init nodeEnv", nodeEnv);
      if (Paddle) {
        Paddle.Environment.set(nodeEnv);
        Paddle.Setup({
          // vendor: paddleVendorId,
          seller: paddleVendorId,
          pwCustomer: pwCustomer,
          eventCallback: ({ name, type, data, details, height }) => {

            if (height && parseInt(height)) {
              this.customHeight = `height:${parseInt(height) + 70}px;`
            }

            if (nodeEnv != 'production') {
              console.log("eventData", name, type, data, details, height);
            }

            let event = name || type || "";
            let eventData = data || details || {};
            let userData = eventData.user || eventData.customer || "";
            let priceData = eventData.totals || "";

            if (priceData) {
              this.paddlePriceData = priceData;
            }

            if (event.includes('checkout.customer') && eventData.customer) {
              this.form.email = userData.email;

              if (userData.address) {
                this.form.residence = userData.address.country_code;
                this.form.residence_business = userData.address.country_code;
              }

              if (!userData.business || !userData.business.tax_identifier) {
                this.form.eu_vat_number = '';
                this.form.eu_vat_valid = 0;
                this.form.user_type = 1;
                this.checkVatNumber();
              }

              if (userData.business) {
                let vatNumber = userData.business.tax_identifier;
                if (vatNumber) {
                  this.form.eu_vat_number = `${userData.address.country_code}${vatNumber}`;
                  this.form.eu_vat_valid = 1;
                  this.form.user_type = 2;
                }
              }
            }

            if (event.includes('checkout.completed')) {
              this.checkPaddlePurchase();
            }

            if (event == 'Checkout.CountryChanged') {
              this.form.residence = eventData.selected_country;
              this.form.residence_business = eventData.selected_country;
              this.checkVatNumber();
            }

            if (event == 'Checkout.Vat.Applied' || event == 'Checkout.Vat.Submit') {
              let vatNumber = eventData.vat_number;
              this.form.eu_vat_number = `${eventData.selected_country || userData.country}${vatNumber}`;
              this.form.user_type = 2;
              this.form.residence = eventData.selected_country || userData.country;
              this.form.residence_business = eventData.selected_country || userData.country;
              this.checkVatNumber();
            }
            if (event == 'Checkout.Vat.Remove') {
              this.form.eu_vat_number = '';
              this.form.eu_vat_valid = 0;
              this.form.user_type = 1;
              this.form.residence = eventData.selected_country || userData.country;
              this.form.residence_business = eventData.selected_country || userData.country;
              this.checkVatNumber();
            }
            if (event == 'Checkout.Coupon.Applied') {
              let discountCode = eventData.coupon.coupon_code;
              this.form.discount_code = discountCode;
              this.checkVatNumber();
            }
            if (event == 'Checkout.Coupon.Remove') {
              this.form.discount_code = "";
              this.checkVatNumber();
            }
          }
        });
        if (!this.paddle_init) {
          this.form.pay_method = '';
        }
        this.paddle_init = true;
      }
    },
    async paddleCheckout() {
      console.log("Paddle Checkout Opening");

      let username = this.username;
      let email = this.form.email;
      let country = this.form.residence;

      if (this.walletData) {
        if (this.walletData.user && this.walletData.user.email) {
          email = this.walletData.user.email;
          country = this.walletData.user.residence;
        }
      }
      
      this.checkoutKey = Math.random().toString(16);

      // Create a Paddle order and initiate the checkout process
      await Paddle.Checkout.open({
        settings: {
          allowLogout: false,
          displayMode: 'inline',
          frameTarget: 'paddleform',
          frameStyle: 'min-height:760px;width:100%; min-width:312px; background-color: transparent; border: none;',
          frameInitialHeight: 450,
        },
        items: [
          {
            priceId: this.selectedProductOption.paddle_product_id,
            quantity: 1,
          },
        ],
        customer: {
          email: email,
          address: {
            countryCode: country,
          },
          business: {
            name: this.form.business_name,
            taxIdentifier: this.form.eu_vat_number,
          },
        },
        discountCode: this.form.discount_code,
        customData: {
          checkout_key: this.checkoutKey,
          username: username,
          scCookie: this.offer.scCookie,
          redirectUrl: this.redirectUrl,
          callbackUrl: this.callbackUrl,
          licenseKey: this.licenseKey,
          redirect: this.noRedirect == "true" ? true : false
        },
        method: 'inline', // set to `inline`
        product: this.selectedProductOption.paddle_product_id,
        allowQuantity: false,
        disableLogout: true,
        frameTarget: 'paddleform', // className of your checkout <div>
        frameInitialHeight: 450, // `450` or above
        frameStyle: 'min-height:760px;width:100%; min-width:312px; background-color: transparent; border: none;',
        email: email,
        country: country,
        passthrough: {
          checkout_key: this.randomKey,
          username: username,
          scCookie: this.offer.scCookie,
          redirectUrl: this.redirectUrl,
          callbackUrl: this.callbackUrl,
          licenseKey: this.licenseKey,
          redirect: this.noRedirect == "true" ? true : false
        },
        success: (data) => {
          // The payment was successful
          console.log(data);
        },
        close: () => {
          this.isPaddleOpen = false;
          // The checkout was closed
        },
        successCallback: (data) => {
          // The payment was successful
          this.checkPaddlePurchase();
          console.log("successCallback", data);
        },
        closeCallback: (data) => {
          console.log("closeCallback", data);
        },
        loadCallback: (data) => {
          console.log("loadCallback", data);
        }
      });
      this.isPaddleOpen = true;
    },
    clearErrorItem(key) {
      let keyPosition = this.errors.indexOf(key);
      if (keyPosition != -1) {
        this.errors.splice(keyPosition, 1);
      }
      delete this.errorMessages[key];
    },
    checkWallet() {
      let formData = new FormData();
      formData.append("user_id", this.userId);
      formData.append("offer_id", this.offer.offerId);
      formData.append("current_url", window.location.href);
      scAxios.post(`purchase/buy-user-auth`, formData).then((response) => {
        this.walletData = response.data;
        if (this.walletData.cards && this.walletData.cards.length > 0) {
          this.selected_card = this.walletData.cards[0];
        }

        // if (
        //   this.walletData.vatDetails &&
        //   this.walletData.vatDetails.residence_country
        // ) {
        //   this.form.residence = this.form.residence_business =
        //     this.walletData.vatDetails.residence_country;
        // }

        if (this.walletData.user) {
          this.form.first_name = this.walletData.user.first_name || null;
          this.form.last_name = this.walletData.user.last_name || null;
          this.form.email = this.walletData.user.email || null;
          this.form.business_name = this.walletData.user.business_name || null;
          // this.form.user_type = this.walletData.user.user_type || null;
          // this.form.eu_vat_number = this.walletData.user.eu_vat_number || null;
          // this.form.residence_business = this.walletData.user.residence || null;
          // this.form.residence = this.walletData.user.residence || null;
          this.form.is_referral =
            this.walletData.wallet_setup == "Yes" ? false : true;
        }
        if (
          !this.isBalanceExists && (!this.walletData.cardcount || !this.eligibleCards || !this.eligibleCards.length)
        ) {
          this.addNewCard = true;
        }
      });
    },
    togglePayMethod(type) {
      if (this.selectedProductOption.paddle_product_id && this.selectedProductOption.paddle_product_id.length) {
        this.setPayType(type);
        return;
      }
      this.form.pay_method = type;
    },
    toggleDiscountBox() {
      this.showDiscount = !this.showDiscount;
    },
    getOptions() {
      scAxios.get(`embed/form-options`).then((response) => {
        this.countries = response.data.countries;
        this.country = response.data.country;
        this.vatRate = response.data.vat_rate
          ? parseFloat(response.data.vat_rate)
          : 0;
        setTimeout(() => {
          if (!this.form.residence.length) {
            this.form.residence =
              this.form.nationality =
              this.form.residence_business =
              this.country;
          }
        }, 1000);
        if (this.dcode) {
          this.form.discount_code = this.dcode;
          this.toggleDiscountBox();
          this.checkVatNumber();
        }
      });
    },
    checkVatNumber(type = "all") {
      if (!this.selectedCountry && !this.form.residence) {
        return;
      }
      if (type == "vat") {
        this.vatLoader = true;
      } else if (type == "dcode") {
        this.dCodeLoader = true;
      } else {
        // this.$emit("loader", true);
      }
      let formData = new FormData();
      formData.append("countryCode", this.selectedCountry.alpha_2 || this.form.residence);
      formData.append("offer_id", this.form.offer_id);
      formData.append("optionId", this.form.optionId);
      formData.append("discountCode", this.form.discount_code);
      formData.append("eu_vat_number", this.form.eu_vat_number);
      formData.append("user_type", this.form.user_type);
      formData.append("offerSlug", this.offer.secret_link);
      formData.append("scembdt", this.offer.scembdt);
      formData.append("userId", this.userId);
      scAxios
        .post(`embed/vat-amount-apply-discount-code`, formData)
        .then((response) => {
          this.successMessages = {};
          // this.errorMessages = {};

          this.discount = response.data;
          if (
            this.isEU &&
            this.form.eu_vat_number.length &&
            (!this.discount.hasOwnProperty("euVatValid") ||
              !this.discount.euVatValid)
          ) {
            this.errorMessages["eu_vat_number"] =
              "The EU Vat Number is not valid. Delete it or enter a correct one.";
            this.form.eu_vat_valid = 0;
          }
          if (
            this.isEU &&
            this.form.eu_vat_number.length &&
            this.discount.hasOwnProperty("euVatValid") &&
            this.discount.euVatValid
          ) {
            this.successMessages["eu_vat_number"] =
              "The EU Vat Number is valid.";
            this.form.eu_vat_valid = 1;
            delete this.errorMessages["eu_vat_number"];
          }

          if (
            this.form.discount_code.length &&
            this.discount.hasOwnProperty("message") &&
            this.discount.hasOwnProperty("discount_id") &&
            this.discount.message
          ) {
            this.successMessages["discount_code"] = this.discount.message;
          }

          if (
            this.form.discount_code.length &&
            this.discount.hasOwnProperty("message") &&
            !this.discount.hasOwnProperty("discount_id") &&
            this.discount.message
          ) {
            this.errorMessages["discount_code"] = this.discount.message;
          }

          if (
            !this.isBalanceExists &&
            (!this.walletData.cardcount || !this.eligibleCards || !this.eligibleCards.length)
          ) {
            this.addNewCard = true;
          } else {
            if (this.hasParent) {
              this.addNewCard = true;
            } else {
              this.addNewCard = false;
            }
          }

          this.dCodeLoader = false;
          this.vatLoader = false;
          this.$emit("loader", false);
        })
        .catch((err) => {
          this.dCodeLoader = false;
          this.vatLoader = false;
          this.$emit("loader", false);
          console.log(err);
        });
    },
    submitFormQuickBuy() {
      let formData = new FormData();
      formData.append("offer_id", this.offer.offerId);
      formData.append("option_id", this.form.optionId);
      formData.append("parent", this.parent);
      formData.append(
        "offer_discount_id",
        this.discount && this.discount.discount_id
          ? this.discount.discount_id
          : ""
      );

      if (!this.isBalanceExists) {
        formData.append(
          "selected_card_id",
          ["FONDY_CARD", "STRIPE_CARD", "PADDLE_CARD"].includes(this.selected_card.type)
            ? this.selected_card.id
            : this.selected_card.mp_creditcard_id
        );
        formData.append("selected_card_type", this.selected_card.type);
      }

      formData.append("scCookie", this.offer.scCookie);

      Object.keys(this.clientData).forEach((key) => {
        formData.append(`clientData[${key}]`, this.clientData[key]);
      });

      this.$emit("loader", true);

      scAxios.post(`quick-buy-offer`, formData).then(({ data }) => {
        if ("string" === typeof data.process) {
          var _process = data.process.toLowerCase();
          if ("authentication" == _process) {
            if (data.is_subscription) {
              this.confirmIntent(
                data.token,
                data.enc_order_id,
                data.payment_method
              );
            } else {
              this.confirmPayment(
                data.token,
                data.enc_order_id,
                data.payment_method
              );
            }
          } else if ("success" == _process) {
            this.responseRedirectURL = decodeURI(data.redirectURL).replaceAll("~AND~", "&");
            this.showSuccessMessage("Success", this.responseRedirectURL);
            if (
              typeof data.redirectURL !== "undefined" &&
              data.redirectURL !== ""
            ) {
              window.location.href = this.responseRedirectURL;
            } else {
              window.location.href =
                scBaseUrl +
                this.username +
                "/purchases/" +
                this.offer.slug +
                "/" +
                data.sale;
            }
          } else if ("fail" == _process) {
            if (
              "undefined" !== typeof data.redirectURL &&
              "" !== data.redirectURL
            ) {
              window.location.href = decodeURI(data.redirectURL).replaceAll("~AND~", "&");
            } else {
              this.showBuyError(data.message, data);
            }
          } else if ("redirect" == _process) {
            if (
              typeof data.redirectURL !== "undefined" &&
              data.redirectURL !== ""
            ) {
              window.location.href = decodeURI(data.redirectURL).replaceAll("~AND~", "&");
            }
            this.$emit("loader", false);
          }
        }
      });
    },
    async _submitForm() {
      if (this.isEmailExist || this.walletError) {
        return false;
      }
      this.errors = [];
      this.errorMessages = {};
      let required = [];
      if (!this.isWalletSetup) {
        required = ["first_name", "last_name"];
        if (this.form.user_type == 2 || this.form.user_type == 3) {
          required = [...required, ...["business_name", "residence_business"]];
        }

        if (this.form.is_referral) {
          if (this.form.user_type == 2) {
            required = [...required, ...["company_number"]];
          }
          if (this.form.user_type != 1) {
            required = [...required, ...["address1", "address2", "city", "state", "post_code"]];
          }
          required = [...required, ...["dob", "residence", "nationality"]];
        }
        if (!this.userId) {
          required.push("email");
        }
      }

      if (!this.form.pay_method && !this.isSecondaryCheckout) {
        required = [
          ...required,
          ...["credit_card_number", "credit_card_expiry", "credit_card_cvc"],
        ];
      }
      for (const item of required) {
        if (
          this.form.hasOwnProperty(item) &&
          !this.form[item].toString().length &&
          !this.errors.includes(item)
        ) {
          this.errors.push(item);
          if (item == "dob") {
            this.errorMessages[item] = "Please choose your date of birth.";
          } else {
            this.errorMessages[item] =
              "Please enter " + item.replace(/_/g, " ") + ".";
          }
        }
      }

      if (!this.userId) {
        // let textOnlyCheck = ["first_name", "last_name"];
        // for (const field of textOnlyCheck) {
        //   // match name with regular expression
        //   if (!this.form[field].match(/^[A-Za-z]+$/)) {
        //     this.errors.push(field);
        //     this.errorMessages[field] = "Please enter letters only.";
        //   }
        // }

        let emailCheck = ["email"];
        for (const field of emailCheck) {
          if (!this.validateEmail(this.form[field])) {
            this.errors.push(field);
            this.errorMessages[field] = "Please enter a valid email address.";
          }
        }
      }

      if (!this.form.pay_method && !this.isSecondaryCheckout) {
        if (!this.detectValidCardType(this.form.credit_card_number)) {
          this.errors.push("credit_card_number");
          this.errorMessages["credit_card_number"] =
            "Only Visa or Mastercard allowed.";
        }
      }

      if (this.isSecondaryCheckout) {
        await this.createStripeToken();
      }

      if (this.errors.length) {
        return;
      }

      if (
        this.form.user_type == 2 &&
        this.form.company_number.length &&
        !this.isValidCompanyNumber(this.form.company_number)) {
        this.errors.push("company_number");
        this.errorMessages["company_number"] = "Please provide valid company number.";
      }

      if (
        this.isEU &&
        this.form.user_type != 1 &&
        this.form.eu_vat_number.length &&
        (!this.discount.hasOwnProperty("euVatValid") ||
          !this.discount.euVatValid)
      ) {
        this.checkVatNumber();
        this.errors.push("eu_vat_number");
        this.errorMessages["eu_vat_number"] =
          "The EU Vat Number is not valid. Delete it or enter a correct one.";
      }

      if (this.errors.length) {
        return;
      }

      this.reportSubmit(true);

      // this._getPaymentToken();

      let formData = new FormData();
      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key]);
      });

      Object.keys(this.clientData).forEach((key) => {
        formData.append(`clientData[${key}]`, this.clientData[key]);
      });

      formData.append("parent", this.parent);
      formData.append("offerSlug", this.offer.secret_link);
      formData.append("scembdt", this.offer.scembdt);

      if (this.userId) {
        formData.append("user_id", this.userId);
      }

      formData.delete("credit_card_cvc");
      formData.delete("credit_card_expiry");
      formData.delete("credit_card_number");
      formData.delete("dob");

      formData.append("dob", this.form.dob);
      formData.append("scCookie", this.offer.scCookie);
      // formData.append("force_secondary", this.force_secondary);
      //Disable force secondary
      formData.append("force_secondary", false);
      formData.append("redirect", this.isThirdParty ? 0 : 1);
      formData.append("redirectUrl", decodeURI(this.redirectUrl).replaceAll("~AND~", "&"));
      formData.append("callbackUrl", decodeURI(this.callbackUrl).replaceAll("~AND~", "&"));
      formData.append("licenseKey", this.licenseKey);

      this.$emit("loader", true);

      scAxios
        .post(`embed/purchase`, formData)
        .then((response) => {
          if (response.data.success === false) {
            this.showBuyError(response.data.message, response);
            return false;
          }
          if (response.data.status == "Error_Reg_validate") {
            this.$emit("loader", false);
            this.showBuyError(
              response.data.message ||
              "Unable to process request. Please check provided details.",
              response
            );
            for (const item in response.data.errors) {
              if (
                response.data.errors.hasOwnProperty(item) &&
                !this.errors.includes(item)
              ) {
                this.errors.push(item);
              }
            }
            return false;
          }

          if (this.form.pay_method) {
            if (response.data.process == 'success'
              && response.data.payment_status == 'approved'
              && response.data.status == '1'
              && response.data.price == '0'
            ) {
              this.buySuccessHandler(response.data);
            } else if (
              typeof response.data.redirect_url !== "undefined" &&
              response.data.redirect_url !== ""
            ) {
              // window.location.href = url;
              this.makePopup(response.data.redirect_url);
              this.checkPurchase(response.data.enc_order_id);
              this.$emit("loader", false);
            } else {
              this.showBuyError("Unable to get Redirect URL.", response);
            }
          } else {
            if (response.data.pay_method == "mangopay") {
              this.cardRegister(response.data);
            } else {
              this.force_secondary = true;
              if (response.data.response_status == "success") {
                if (response.data.is_subscription) {
                  this.confirmStripeIntent(
                    response.data.token,
                    response.data.enc_order_id
                  );
                } else {
                  this.confirmStripePayment(
                    response.data.token,
                    response.data.enc_order_id
                  );
                }
              } else {
                this.showBuyError(
                  response.data.message || "Error in Order Response.",
                  response
                );
              }
            }
            // else {
            //   if (
            //     response.data.response_status == "success" &&
            //     response.data.token.length
            //   ) {
            //     this.force_secondary = false;
            //     this.fondyCardCheckout(response.data.token);
            //   } else {
            //     this.showBuyError("Invalid payment details.", response);
            //   }
            // }
          }
        })
        .catch((err) => {
          this.showBuyError("Something wrong with purchase api response.", err);
          this.$emit("loader", false);
          console.log(err);
        });
    },
    _getPaymentToken() {
      let formData = new FormData();
      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key]);
      });

      formData.append("offerSlug", this.offer.secret_link);
      formData.append("scembdt", this.offer.scembdt);

      if (this.userId) {
        formData.append("user_id", this.userId);
      }

      formData.delete("credit_card_cvc");
      formData.delete("credit_card_expiry");
      formData.delete("credit_card_number");
      formData.delete("dob");

      formData.append("dob", this.form.dob);
      formData.append("scCookie", this.offer.scCookie);
      formData.append("force_secondary", this.force_secondary);
      formData.append("redirect", this.isThirdParty ? 0 : 1);
      formData.append("redirectUrl", this.redirectUrl);
      formData.append("callbackUrl", this.callbackUrl);
      formData.append("licenseKey", this.licenseKey);
      this.$emit("loader", true);

      scAxios
        .post(`embed/purchase/token`, formData)
        .then((response) => {
          if (response.data.token.response_status == "success") {
            this.fondyCardCheckout(response.data.token.token);
          }
        })
        .catch((err) => {
          this.showBuyError("Something wrong with purchase api response.");
          this.$emit("loader", false);
          console.log(err);
        });
    },
    fondyCardCheckout(token) {
      // console.log(`fondyCardCheckout`, token);

      let params = {
        payment_system: "card",
        // "merchant_id":"1397120",
        token: token,
        card_number: this.form.credit_card_number,
        expiry_date: this.form.credit_card_expiry,
        cvv2: this.form.credit_card_cvc,
      };
      // console.log(`fondyCardCheckout`, params);
      this.fondyCheckout = $checkout("Api");
      // this.fondyCheckout.setOrigin("https://www.api.dev..fondy.eu");
      let self = this;
      this.fondyCheckout.scope(function () {
        this.request("api.checkout.form", "request", params)
          .done(function (model) {
            model.sendResponse();
            let result = model.attr("order");
            if (
              result.response_status == "success" &&
              result.order_data.order_status == "approved"
            ) {
              self.checkPurchase(result.order_data.product_id);
            } else {
              self.showBuyError("Error in Order Response.", result);
            }
          })
          .fail(function (model) {
            // console.log("Error Checkout", model);
            self.showBuyError(model.data.error.message, {
              error: model.data.error,
              order_data: model.data.order,
            });
            self.$emit("loader", false);

            // console.log(model.attr('error'));
          });
      });
    },
    checkPaddlePurchase() {
      this.$emit("loader", true);
      if (this.purchaseCheckInterval) {
        clearInterval(this.purchaseCheckInterval);
      }
      this.purchaseCheckInterval = setInterval(() => {
        this.getPaddlePurchaseStatus(this.checkoutKey);
      }, 3000);
    },
    getPaddlePurchaseStatus(orderId) {
      scAxios
        .get(`embed/purchase/paddle-process/${orderId}`)
        .then((response) => {
          if (parseInt(response.data.process) == 2) {
            clearInterval(this.purchaseCheckInterval);
            this.showBuyError(response.data.message || "Payment Declined.", response.data);
          }
          else {
            if (response.data.status == 1) {
              clearInterval(this.purchaseCheckInterval);
              this.buySuccessHandler(response.data);
            } else if (response.data.status != 0) {
              clearInterval(this.purchaseCheckInterval);
              this.showBuyError(response.data.message, response.data);
            }
          }
          this.$emit("loader", true);
        })
        .catch((err) => {
          // clearInterval(this.purchaseCheckInterval);
          // this.showBuyError("Invalid Purchase data.");
        });
    },
    checkPurchase(orderId, payment_method = false) {
      if (this.purchaseCheckInterval) {
        clearInterval(this.purchaseCheckInterval);
      }
      this.purchaseCheckInterval = setInterval(() => {
        this.getPurchaseStatus(orderId, payment_method);
      }, 3000);
    },
    getPurchaseStatus(orderId, payment_method = false) {
      scAxios
        .get(`embed/purchase/process/${orderId}`)
        .then((response) => {
          if (parseInt(response.data.process) == 2) {
            clearInterval(this.purchaseCheckInterval);
            this.showBuyError(response.data.message || "Payment Declined.", response.data);
          }
          else if (response.data.secret && response.data.secret.length) {
            clearInterval(this.purchaseCheckInterval);
            if (payment_method) {
              this.confirmPayment(
                response.data.secret,
                orderId,
                payment_method
              );
            } else {
              this.confirmStripePayment(response.data.secret, orderId);
            }
          } else {
            if (response.data.status == 1) {
              clearInterval(this.purchaseCheckInterval);
              this.buySuccessHandler(response.data);
            } else if (response.data.status != 0) {
              clearInterval(this.purchaseCheckInterval);
              this.showBuyError(response.data.message, response.data);
            }
          }
        })
        .catch((err) => {
          clearInterval(this.purchaseCheckInterval);
          this.showBuyError("Invalid Purchase data.");
        });
    },
    cardRegister(response) {
      // Initialize with card register data prepared on the server
      mangoPay.cardRegistration.init({
        cardRegistrationURL: response.CardRegistrationURL,
        preregistrationData: response.PreregistrationData,
        accessKey: response.AccessKey,
        Id: response.cardRegistrationId,
      });

      let cardCvx = this.form.credit_card_cvc;
      let cardNumber = this.form.credit_card_number.split("-").join("");
      let cardExpirationDate = this.form.credit_card_expiry.split("/").join("");

      let cardData = {
        cardNumber: cardNumber,
        returnURL: response.returnUrl,
        cardExpirationDate: cardExpirationDate,
        cardCvx: cardCvx,
      };
      // console.log("cardRegister_data", cardData);

      // Register card
      mangoPay.cardRegistration.registerCard(
        cardData,
        // Success
        (success) => {
          // console.log("cardRegister_success", success);
          // this.makePopup(cardData.redirect_url);
          this.sendMPtokenization(success);
          this.checkPurchase(response.enc_order_id);
        },

        // Failure
        (error) => {
          console.log("cardRegister_error", error);
          // this._submitForm();

          this.force_secondary = true;

          var errmessage = "";
          try {
            if (
              "undefined" !== typeof error.ResultCode &&
              "string" === typeof error.ResultMessage
            ) {
              errmessage = error.ResultMessage;
            } else if (
              "string" === typeof error.status &&
              "string" === typeof error.message
            ) {
              errmessage = error.message;
            }
            this.showBuyError(
              // Disable Stripe
              // "Payment failed! Please enter your credit card details again, we'll process the payment via a different provider.",
              "Payment failed. Please try another payment method.",
              error
            );
            // this.showBuyError(errmessage, error);
          } catch (err) {
            this.showBuyError(
              // Disable Stripe
              // "Payment failed! Please enter your credit card details again, we'll process the payment via a different provider.",
              "Payment failed. Please try another payment method.",
              err
            );
          }
        }
      );
    },
    sendMPtokenization(response) {
      var status = "fail";
      // console.log("sendMPtokenization", response, typeof response);

      try {
        response = JSON.parse(response);

        if ("object" != typeof response) {
          this.showBuyError("Mangopay Tokenization response failed.", response);
          return;
        }

        if (
          "string" === typeof response.status ||
          "number" === typeof response.status
        ) {
          status = response.status;
          // console.log("status", status);
          switch (status.toString()) {
            case "success":
              // console.log(this.isValidUrl(response.redirectURL));
              if (this.isValidUrl(response.redirectURL)) {
                this.buySuccessHandler(response);
              } else {
                this.$emit("loader", false);
              }
              break;
            case "1":
              // console.log(this.isValidUrl(response.redirectURL));
              if (this.isValidUrl(response.redirectURL)) {
                this.buySuccessHandler(response);
              } else {
                this.$emit("loader", false);
              }
              break;

            case "redirect":
              if (this.isValidUrl(response.redirectURL)) {
                console.log("redirecting");

                this.secure_status = true;
                this.reportSubmit(true);
                setTimeout(() => {
                  // new flow
                  this.makePopup(response.redirectURL);
                }, 5000);
              }
              break;

            default:
              // this._submitForm();

              if ("undefined" !== typeof response.message) {
                var message = response.message;
              }
              this.showBuyError(
                // Disable Stripe
                // "Payment failed! Please enter your credit card details again, we'll process the payment via a different provider.",
                "Payment failed. Please try another payment method.",
                response
              );
              break;
          }
        }
      } catch (err) {
        this.showBuyError(
          // Disable Stripe
          // "Payment failed! Please enter your credit card details again, we'll process the payment via a different provider.",
          "Payment failed. Please try another payment method.",
          err
        );
        // this._submitForm();
      }
    },
    checkEmailExist() {
      if (this.email && this.email.length) {
        this.isEmailExist = false;
        return false;
      }
      this.isEmailExist = false;
      let postData = new FormData();
      postData.append("email", this.form.email);
      postData.append("offerSlug", this.offer.secret_link);
      postData.append("scembdt", this.offer.scembdt);

      scAxios.post(`/embed/check-user-exist`, postData).then((response) => {
        if (response.data.status == "fail") {
          this.isEmailExist = true;
        }
        this.reportSubmit();
      });
    },
    showBuyError(error = "Oops! Something went wrong.", errorObject = "") {
      this.force_secondary = true;

      if (this.purchaseCheckInterval) {
        clearInterval(this.purchaseCheckInterval);
      }
      this.resultErrorMessage = error;
      const substringToCheck = "009199";
      if (this.resultErrorMessage.includes(substringToCheck)) {
        this.resultErrorMessage = "Our Credit Card payment processor is facing issues. Please pay via PayPal, or contact us at support@sellcodes.com so that we can arrange alternative ways of payments, or notify you when the issue is corrected. Thank you!";
      }
      this.$emit("loader", false);
      console.log("Error", error);
      this.reportError(error, errorObject);
      if (sellCodesEmbedPurchase._popupInstance) {
        sellCodesEmbedPurchase._popupInstance.close();
      }
    },
    reportError(errorMsg, errorObject) {
      this.reportSubmit(true, "Failed", errorMsg);
      let formData = new FormData();
      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key]);
      });

      Object.keys(this.clientData).forEach((key) => {
        formData.append(`clientData[${key}]`, this.clientData[key]);
      });

      formData.append("offerSlug", this.offer.secret_link);
      formData.append("scembdt", this.offer.scembdt);

      formData.append("message", errorMsg);
      formData.append("errors", JSON.stringify(errorObject));

      if (this.userId) {
        formData.append("user_id", this.userId);
      }

      formData.delete("credit_card_cvc");
      formData.delete("credit_card_expiry");
      formData.delete("credit_card_number");
      formData.delete("dob");

      formData.append("dob", this.form.dob);
      formData.append("scCookie", this.offer.scCookie);

      scAxios
        .post(`embed/issues/${this.offer.secret_link}`, formData)
        .then((result) => {
          // console.log(result.data.msg);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reportSubmit(pay = false, payment_status = null, payment_reason = null) {
      // console.log("Sending Reports");
      let formData = new FormData();

      if (this.reportId) {
        formData.append("report_id", this.reportId);
      }
      if (this.clientData) {
        formData.append("device", this.clientData.device || "");
        formData.append(
          "operating_system",
          this.clientData.operating_system || ""
        );
        formData.append("browser", this.clientData.browser || "");
        formData.append("browser_language", this.clientData.lang || "");
      }
      if (this.offer && this.offer.ID) {
        formData.append("offer_id", this.offer.ID);
      }
      if (this.selectedProductOption) {
        formData.append("option_id", this.selectedProductOption.ID);
      }
      if (this.form.email) {
        formData.append(
          "email",
          this.email.length ? this.email.replace(/ /g, "+") : this.form.email
        );
      }
      if (this.isEmailExist) {
        formData.append("existing_user", this.isEmailExist ? "Yes" : "No");
      }
      if (pay) {
        formData.append(
          "payment_method",
          this.form.pay_method ? "Paypal" : "Card"
        );
        formData.append("started_payment", "Yes");
        formData.append("secure_status", this.secure_status ? "Yes" : "No");
      }
      if (payment_status) {
        formData.append("payment_status", payment_status);
      }
      if (payment_reason) {
        formData.append("payment_reason", payment_reason);
      }
      formData.append("open_at_url", window.location.href);

      scAxios
        .post(`embed/reports`, formData)
        .then((result) => {
          // console.log(result.data);
          this.reportId = result.data.report_id;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showSuccessMessage(message, scRedirect) {
      this.$emit("loader", false);
      // console.log("showSuccessMessage", message);
      let purchaseSuccessMsg = "Purchase successful!";
      let purchaseRedirectionMsg =
        " Redirecting you so that you can access it.";
      message = !scRedirect
        ? purchaseSuccessMsg
        : purchaseSuccessMsg + purchaseRedirectionMsg + `<br/> Please <a href="${scRedirect}">click here</a> if not redirect within 10 seconds.`;
      this.resultMessage = message;
      this.reportSubmit(true, "Paid");
    },
    buySuccessHandler(response) {
      response.product_id = this.offer.secret_link;
      // call embedded listener
      var data = {
        type: "SELLCODES_PURCHASE_MESSAGE",
        response: response,
      };
      window.parent.postMessage(JSON.stringify(data), "*");
      // if (window.parent && window.parent.document) {
      //   var event = new CustomEvent("sellcodesSuccessEvent", response);
      //   window.parent.document.dispatchEvent(event);
      //   return true;
      // }

      // show success message
      // if (typeof window.sellcodesSuccess === "function") {
      //   this.showSuccessMessage(response.message, false);
      //   // remove redirect URL from details
      //   delete response.redirectURL;
      //   // call embedded listener
      //   window.sellcodesSuccess(response);
      //   this.$emit("close");
      // } else

      if (this.callbackUrl.length && this.redirectUrl.length && this.noRedirect != "true") {
        this.responseRedirectURL = decodeURI(this.redirectUrl || response.redirectURL).replaceAll("~AND~", "&");
        this.responseRedirectURL = this.decorateUrlWithGa(this.responseRedirectURL);
        this.showSuccessMessage(response.message, this.responseRedirectURL);
        setTimeout(() => {
          console.log("Redirecting to redirectUrl");
          window.open(this.responseRedirectURL, "_parent");
        }, 1800);
      } else if (this.noRedirect == "true") {
        console.log("No Redirect");
        this.showSuccessMessage(response.message, false);
        this.$emit("close");
      } else {
        this.responseRedirectURL = decodeURI(response.redirectURL).replaceAll("~AND~", "&");
        this.responseRedirectURL = this.decorateUrlWithGa(this.responseRedirectURL);
        this.showSuccessMessage(response.message, this.responseRedirectURL);
        if (response.redirectURL) {
          console.log("Redirecting");
          window.parent.postMessage("sellcodesLoaderHide", "*");
          this.$emit("loader", false);
          setTimeout(() => {
            // window.location = this.decorateUrlWithGa(response.redirectURL);
            window.open(
              this.responseRedirectURL,
              "_parent"
            );
          }, 1800);
        } else {
          console.log(response);
        }
      }

      // close popup
      // this.$emit("close");
      // hide loading
      this.$emit("loader", false);
    },
    buyErrorHandler(response) {
      // console.log("buyErrorHandler", response.message);
      this.resultErrorMessage = response.message;
      this.$emit("loader", false);
      this.reportSubmit(true, "Failed", response.message);
      if (sellCodesEmbedPurchase._popupInstance) {
        sellCodesEmbedPurchase._popupInstance.close();
      }
    },
    makePopup(url) {
      url = decodeURI(url).replaceAll("~AND~", "&");
      // window.location.href = url;
      // window.open(url, "_parent");
      // return false;

      if (sellCodesEmbedPurchase._popupInstance) {
        sellCodesEmbedPurchase._popupInstance.close();
      }

      this.$emit("loader", false);

      var name = "sellCodesProcessPurchase";

      var dualScreenWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        window.screen.width;
      var dualScreenHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        window.screen.height;
      var dualScreenLeft = window.screenLeft || window.screen.left;
      var dualScreenTop = window.screenTop || window.screen.top;

      var specs = {
        width: 600,
        height: 720,
        toolbar: 0,
        menubar: 0,
        location: 0,
        status: 1,
        scrollbars: 1,
        resizable: 1,
      };

      specs.left = dualScreenWidth / 2 - specs.width / 2 + dualScreenLeft;
      specs.top = dualScreenHeight / 2 - specs.height / 2 + dualScreenTop;

      // Open new window
      sellCodesEmbedPurchase._popupInstance = window.open(
        url,
        name,
        Object.keys(specs)
          .reduce(function (acc, key) {
            acc.push(key + "=" + specs[key]);
            return acc;
          }, [])
          .join(","),
        true
      );

      if (this.closeCheckInterval) {
        clearInterval(this.closeCheckInterval);
      }
      this.closeCheckInterval = setInterval(() => {
        if (
          sellCodesEmbedPurchase._popupInstance &&
          sellCodesEmbedPurchase._popupInstance.closed
        ) {
          clearInterval(this.closeCheckInterval);
          this.reportSubmit(
            true,
            "Failed",
            "Payment window closed without payment."
          );
        }
      }, 2000);

      if (!sellCodesEmbedPurchase._popupInstance) {
        if (this.isThirdParty) {
          if (this.callbackUrl.length && this.redirectUrl.length) {
            if (sellCodesEmbedPurchase._popupInstance) {
              sellCodesEmbedPurchase._popupInstance.close();
            }
            window.open(url, "_parent");
          } else {
            this.buyErrorHandler({
              status: false,
              message:
                "Payment Pop-up blocked! Please allow pop-up to process payment.",
            });
          }
        } else {
          if (sellCodesEmbedPurchase._popupInstance) {
            sellCodesEmbedPurchase._popupInstance.close();
          }
          window.open(url, "_parent");
        }
        // window.location.href = url;
      }

      window.addEventListener("message", (e) => {
        this._handlePopUpListener(e);
      });
    },
    /**
     * Handle callbacks from popup window.
     *
     * @param {object} e
     */
    _handlePopUpListener(e) {
      // new flow
      if (typeof e.data === "string" && e.origin === this.scBaseUrl) {
        if (this.closeCheckInterval) {
          clearInterval(this.closeCheckInterval);
        }

        var data = JSON.parse(e.data);
        console.log("SELLCODES_PURCHASE_MESSAGE", data);
        if (
          typeof data.type === "string" &&
          data.type.toUpperCase() === "SELLCODES_PURCHASE_MESSAGE"
        ) {
          if (sellCodesEmbedPurchase._popupInstance) {
            sellCodesEmbedPurchase._popupInstance.close();
          }
          if (typeof data.response !== "object") {
            this.buyErrorHandler({
              status: false,
              message: "Request processing error",
            });
          } else {
            if (data.response.status === true) {
              this.showSuccessMessage("Success", false);
              this.buySuccessHandler(data.response.data);
            } else {
              this.buyErrorHandler(data.response);
            }
          }

          window.removeEventListener("message", (e) => {
            this._handlePopUpListener(e);
          });
        }
      }
    },
    getClientData() {
      this.clientData.operating_system =
        scClient.getOS() + " " + scClient.getOSVersion();

      this.clientData.browser =
        scClient.getBrowser() + " " + scClient.getBrowserVersion();
      this.clientData.cpu = scClient.getCPU();

      this.clientData.accept = "application/json,text/javascript,*/*;q=0.01<";
      this.clientData.agent = scClient.getUserAgent();
      this.clientData.java = scClient.isJava();
      this.clientData.lang = scClient.getLanguage() || "en-US";
      this.clientData.device = scClient.getDevice() || this.getDeviceName();
      this.clientData.color_depth = scClient.getColorDepth();
      this.clientData.screen_height = screen.height || 667;
      this.clientData.screen_width = screen.width || 375;
      let date = new Date();
      this.clientData.timezone_offset = date.getTimezoneOffset();
      this.clientData.javascript = true;

      var connection =
        window.navigator.connection ||
        window.navigator.mozConnection ||
        window.navigator.webkitConnection;
      if (connection) {
        this.clientData.network = connection.effectiveType.toString();
      }
      var battery =
        window.navigator.getBattery ||
        window.navigator.webkitBattery ||
        window.navigator.mozBattery ||
        window.navigator.msBattery;
      if (battery) {
        window.navigator.getBattery().then((battery) => {
          this.clientData.battery_charging = battery.charging;
          this.clientData.battery_chargingTime = battery.chargingTime;
          this.clientData.battery_dischargingTime = battery.dischargingTime;
          this.clientData.battery_level = battery.level;
        });
      }

      this.clientData.browser_plugins = scClient.getPlugins();
      this.clientData.fingerprint = scClient.getFingerprint();
      this.clientData.gpu = this.getVideoCardInfo();
    },
    onCloseProductOptions() {
      this.showProductOptions = false;
    },
    onCloseUserType() {
      this.showUserTypes = false;
    },
    async initStripe() {
      this.stripe.client = await loadStripe(stripeKey);
      elements = this.stripe.client.elements();

      let style = {
        base: {
          fontSize: "15px",
          fontFamily: "Lato, Helvetica, sans-serif",
          color: "#282828",
          "::placeholder": {
            color: "#a3aeb9",
          },
        },
      };

      this.stripe.card = elements.create("cardNumber", {
        placeholder: "Card number",
        style: style,
      });

      this.stripe.card.mount(`#${this.formRef}cardNumber`);

      this.stripe.card.addEventListener("change", (event) => {
        if (event.error) {
          this.errors.push("credit_card_number");
          this.errorMessages["credit_card_number"] = event.error.message;
        } else {
          this.clearErrorItem("credit_card_number");
        }
      });

      this.stripe.expiry = elements.create("cardExpiry", {
        style: style,
      });
      this.stripe.expiry.mount(`#${this.formRef}cardExpiry`);

      this.stripe.expiry.addEventListener("change", (event) => {
        if (event.error) {
          this.errors.push("credit_card_expiry");
          this.errorMessages["credit_card_expiry"] = event.error.message;
        } else {
          this.clearErrorItem("credit_card_expiry");
        }
      });

      this.stripe.cvc = elements.create("cardCvc", {
        style: style,
      });

      this.stripe.cvc.mount(`#${this.formRef}cardCvc`);

      this.stripe.cvc.addEventListener("change", (event) => {
        if (event.error) {
          this.errors.push("credit_card_cvc");
          this.errorMessages["credit_card_cvc"] = event.error.message;
        } else {
          this.clearErrorItem("credit_card_cvc");
        }
      });
    },
    async createStripeToken() {
      this.form.payment_token = "";
      await this.stripe.client
        .createToken(this.stripe.card)
        .then((res) => {
          if (res.token) {
            this.form.payment_token = res.token.id;
          } else {
            this.errors.push("credit_card_number");
            this.showBuyError(
              res.error.message || "Invalid card details.",
              res
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async confirmStripePayment(token, order_id) {
      await this.stripe.client
        .confirmCardPayment(token, {
          payment_method: { card: this.stripe.card },
          setup_future_usage: "off_session",
        })
        .then((res) => {
          console.log("paymentIntent", res);
          if (res.error && res.error.payment_intent.status != "succeeded") {
            this.showBuyError(
              res.error.message || "Error in card payment.",
              res
            );
          } else {
            this.retrievePaymentIntent(token, order_id);
          }
        })
        .catch((err) => {
          console.log(err);
          this.showBuyError("Error in card payment.", err);
        });
    },
    async confirmPayment(token, order_id, payment_method) {
      this.stripe.client = await loadStripe(stripeKey);
      await this.stripe.client
        .confirmCardPayment(token, {
          payment_method: payment_method,
          setup_future_usage: "off_session",
        })
        .then((res) => {
          console.log("paymentIntent", res);
          if (res.error && res.error.payment_intent.status != "succeeded") {
            this.showBuyError(
              res.error.message || "Error in card payment.",
              res
            );
          } else {
            this.retrievePaymentIntent(token, order_id, payment_method);
          }
        })
        .catch((err) => {
          console.log(err);
          this.showBuyError("Error in card payment.", err);
        });
    },
    async confirmIntent(token, order_id, payment_method = false) {
      await this.stripe.client
        .confirmCardSetup(token, {
          payment_method: payment_method,
        })
        .then((res) => {
          console.log("confirmStripeIntent", res);
          if (res.error && res.error.setup_intent.status != "succeeded") {
            this.showBuyError(
              res.error.message || "Error in card intent.",
              res
            );
          } else {
            this.retrieveSetupIntent(token, order_id, payment_method);
          }
        })
        .catch((err) => {
          console.log(err);
          this.showBuyError("Error in card intent.", err);
        });
    },
    async confirmStripeIntent(token, order_id) {
      await this.stripe.client
        .confirmCardSetup(token, {
          payment_method: { card: this.stripe.card },
        })
        .then((res) => {
          console.log("confirmStripeIntent", res);
          if (res.error && res.error.setup_intent.status != "succeeded") {
            this.showBuyError(
              res.error.message || "Error in card intent.",
              res
            );
          } else {
            this.retrieveSetupIntent(token, order_id);
          }
        })
        .catch((err) => {
          console.log(err);
          this.showBuyError("Error in card intent.", err);
        });
    },
    retrievePaymentIntent(token, order_id, payment_method = false) {
      this.stripe.client
        .retrievePaymentIntent(token)
        .then(({ paymentIntent }) => {
          let message = "";
          console.log("retrievePaymentIntent", paymentIntent);
          // Some payment methods will [immediately succeed or fail][0] upon
          // confirmation, while others will first enter a `processing` state.
          // [0]: https://stripe.com/docs/payments/payment-methods#payment-notification
          switch (paymentIntent.status) {
            case "succeeded":
              message = "Success! Payment received.";
              this.checkPurchase(order_id, payment_method);
              break;

            case "processing":
              message =
                "Payment processing. We'll update you when payment is received.";
              this.showBuyError(message, paymentIntent);
              break;

            case "requires_payment_method":
              message = "Payment failed. Please try another payment method.";
              this.showBuyError(message, paymentIntent);
              // Redirect your user back to your payment page to attempt collecting
              // payment again
              break;

            default:
              message = "Something went wrong.";
              this.showBuyError(message, paymentIntent);
              break;
          }
          console.log(message);
        });
    },
    retrieveSetupIntent(token, order_id, payment_method) {
      this.stripe.client.retrieveSetupIntent(token).then(({ setupIntent }) => {
        let message = "";
        console.log("retrieveSetupIntent", setupIntent);
        // Some payment methods will [immediately succeed or fail][0] upon
        // confirmation, while others will first enter a `processing` state.
        // [0]: https://stripe.com/docs/payments/payment-methods#payment-notification
        switch (setupIntent.status) {
          case "succeeded":
            message = "Success! Payment received.";
            this.checkPurchase(order_id, payment_method);
            break;

          case "processing":
            message =
              "Payment processing. We'll update you when payment is received.";
            this.showBuyError(message, setupIntent);
            break;

          case "requires_payment_method":
            message = "Payment failed. Please try another payment method.";
            this.showBuyError(message, setupIntent);
            // Redirect your user back to your payment page to attempt collecting
            // payment again
            break;

          default:
            message = "Something went wrong.";
            this.showBuyError(message, setupIntent);
            break;
        }
        console.log(message);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// CheckoutFormComponent.vue?4bde108e